var vt = Object.defineProperty;
var Et = (e, t, n) => t in e ? vt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var x = (e, t, n) => Et(e, typeof t != "symbol" ? t + "" : t, n);
import { TableMap as qe, goToNextCell as Ne, columnResizing as xt, tableEditing as St, CellSelection as Ge, TableView as Bt } from "prosemirror-tables";
import Mt from "@tiptap/extension-bold";
import Tt from "@tiptap/extension-code";
import Lt from "@tiptap/extension-italic";
import At from "@tiptap/extension-strike";
import Nt from "@tiptap/extension-underline";
import { Extension as Ze, combineTransactionSteps as It, getChangedRanges as Pt, findChildrenInRange as Ot, Node as V, Mark as Ht, callOrReturn as Dt, getExtensionField as _t, mergeAttributes as be } from "@tiptap/core";
import { Slice as ke, Fragment as W, DOMParser as ne, DOMSerializer as Ie } from "prosemirror-model";
import { Plugin as Xe, PluginKey as Je, TextSelection as Ke } from "prosemirror-state";
import { v4 as Rt } from "uuid";
import { createHighlightPlugin as Vt } from "prosemirror-highlight";
import { createParser as Wt } from "prosemirror-highlight/shiki";
import { ReplaceStep as jt } from "prosemirror-transform";
import { DecorationSet as Pe, Decoration as Ft } from "prosemirror-view";
function H(e, t) {
  const n = e.resolve(t);
  if (n.nodeAfter && n.nodeAfter.type.isInGroup("bnBlock"))
    return {
      posBeforeNode: n.pos,
      node: n.nodeAfter
    };
  let o = n.depth, r = n.node(o);
  for (; o > 0; ) {
    if (r.type.isInGroup("bnBlock"))
      return {
        posBeforeNode: n.before(o),
        node: r
      };
    o--, r = n.node(o);
  }
  const s = [];
  e.descendants((i, c) => {
    i.type.isInGroup("bnBlock") && s.push(c);
  }), console.warn(`Position ${t} is not within a blockContainer node.`);
  const a = e.resolve(
    s.find((i) => i >= t) || s[s.length - 1]
  );
  return {
    posBeforeNode: a.pos,
    node: a.nodeAfter
  };
}
function Ce(e, t) {
  if (!e.type.isInGroup("bnBlock"))
    throw new Error(
      `Attempted to get bnBlock node at position but found node of different type ${e.type.name}`
    );
  const n = e, o = t, r = o + n.nodeSize, s = {
    node: n,
    beforePos: o,
    afterPos: r
  };
  if (n.type.name === "blockContainer") {
    let a, i;
    if (n.forEach((c, l) => {
      if (c.type.spec.group === "blockContent") {
        const d = c, u = o + l + 1, p = u + c.nodeSize;
        a = {
          node: d,
          beforePos: u,
          afterPos: p
        };
      } else if (c.type.name === "blockGroup") {
        const d = c, u = o + l + 1, p = u + c.nodeSize;
        i = {
          node: d,
          beforePos: u,
          afterPos: p
        };
      }
    }), !a)
      throw new Error(
        `blockContainer node does not contain a blockContent node in its children: ${n}`
      );
    return {
      isBlockContainer: !0,
      bnBlock: s,
      blockContent: a,
      childContainer: i,
      blockNoteType: a.node.type.name
    };
  } else {
    if (!s.node.type.isInGroup("childContainer"))
      throw new Error(
        `bnBlock node is not in the childContainer group: ${s.node}`
      );
    return {
      isBlockContainer: !1,
      bnBlock: s,
      childContainer: s,
      blockNoteType: s.node.type.name
    };
  }
}
function D(e) {
  return Ce(e.node, e.posBeforeNode);
}
function $t(e) {
  if (!e.nodeAfter)
    throw new Error(
      `Attempted to get blockContainer node at position ${e.pos} but a node at this position does not exist`
    );
  return Ce(e.nodeAfter, e.pos);
}
function Qe(e) {
  const t = H(e.doc, e.selection.anchor);
  return D(t);
}
function Ut(e) {
  const t = H(e.doc, e.selection.anchor);
  return D(t);
}
function zt(e, t = JSON.stringify) {
  const n = {};
  return e.filter((o) => {
    const r = t(o);
    return Object.prototype.hasOwnProperty.call(n, r) ? !1 : n[r] = !0;
  });
}
function qt(e) {
  const t = e.filter(
    (o, r) => e.indexOf(o) !== r
  );
  return zt(t);
}
const Ye = Ze.create({
  name: "uniqueID",
  // we’ll set a very high priority to make sure this runs first
  // and is compatible with `appendTransaction` hooks of other extensions
  priority: 1e4,
  addOptions() {
    return {
      attributeName: "id",
      types: [],
      setIdAttribute: !1,
      generateID: () => {
        if (typeof window < "u" && window.__TEST_OPTIONS) {
          const e = window.__TEST_OPTIONS;
          return e.mockID === void 0 ? e.mockID = 0 : e.mockID++, e.mockID.toString();
        }
        return Rt();
      },
      filterTransaction: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          [this.options.attributeName]: {
            default: null,
            parseHTML: (e) => e.getAttribute(`data-${this.options.attributeName}`),
            renderHTML: (e) => {
              const t = {
                [`data-${this.options.attributeName}`]: e[this.options.attributeName]
              };
              return this.options.setIdAttribute ? {
                ...t,
                id: e[this.options.attributeName]
              } : t;
            }
          }
        }
      }
    ];
  },
  // check initial content for missing ids
  // onCreate() {
  //   // Don’t do this when the collaboration extension is active
  //   // because this may update the content, so Y.js tries to merge these changes.
  //   // This leads to empty block nodes.
  //   // See: https://github.com/ueberdosis/tiptap/issues/2400
  //   if (
  //     this.editor.extensionManager.extensions.find(
  //       (extension) => extension.name === "collaboration"
  //     )
  //   ) {
  //     return;
  //   }
  //   const { view, state } = this.editor;
  //   const { tr, doc } = state;
  //   const { types, attributeName, generateID } = this.options;
  //   const nodesWithoutId = findChildren(doc, (node) => {
  //     return (
  //       types.includes(node.type.name) && node.attrs[attributeName] === null
  //     );
  //   });
  //   nodesWithoutId.forEach(({ node, pos }) => {
  //     tr.setNodeMarkup(pos, undefined, {
  //       ...node.attrs,
  //       [attributeName]: generateID(),
  //     });
  //   });
  //   tr.setMeta("addToHistory", false);
  //   view.dispatch(tr);
  // },
  addProseMirrorPlugins() {
    let e = null, t = !1;
    return [
      new Xe({
        key: new Je("uniqueID"),
        appendTransaction: (n, o, r) => {
          const s = n.some((h) => h.docChanged) && !o.doc.eq(r.doc), a = this.options.filterTransaction && n.some((h) => {
            var k, m;
            return !((m = (k = this.options).filterTransaction) != null && m.call(k, h));
          });
          if (!s || a)
            return;
          const { tr: i } = r, { types: c, attributeName: l, generateID: d } = this.options, u = It(
            o.doc,
            n
          ), { mapping: p } = u;
          if (Pt(u).forEach(({ newRange: h }) => {
            const k = Ot(
              r.doc,
              h,
              (y) => c.includes(y.type.name)
            ), m = k.map(({ node: y }) => y.attrs[l]).filter((y) => y !== null), b = qt(m);
            k.forEach(({ node: y, pos: g }) => {
              var $;
              const v = ($ = i.doc.nodeAt(g)) == null ? void 0 : $.attrs[l];
              if (v === null) {
                const U = o.doc.type.createAndFill().content;
                if (o.doc.content.findDiffStart(U) === null) {
                  const Ae = JSON.parse(
                    JSON.stringify(r.doc.toJSON())
                  );
                  if (Ae.content[0].content[0].attrs.id = "initialBlockId", JSON.stringify(Ae.content) === JSON.stringify(U.toJSON())) {
                    i.setNodeMarkup(g, void 0, {
                      ...y.attrs,
                      [l]: "initialBlockId"
                    });
                    return;
                  }
                }
                i.setNodeMarkup(g, void 0, {
                  ...y.attrs,
                  [l]: d()
                });
                return;
              }
              const { deleted: S } = p.invert().mapResult(g);
              S && b.includes(v) && i.setNodeMarkup(g, void 0, {
                ...y.attrs,
                [l]: d()
              });
            });
          }), !!i.steps.length)
            return i.setMeta("uniqueID", !0), i;
        },
        // we register a global drag handler to track the current drag source element
        view(n) {
          const o = (r) => {
            let s;
            e = !((s = n.dom.parentElement) === null || s === void 0) && s.contains(r.target) ? n.dom.parentElement : null;
          };
          return window.addEventListener("dragstart", o), {
            destroy() {
              window.removeEventListener("dragstart", o);
            }
          };
        },
        props: {
          // `handleDOMEvents` is called before `transformPasted` so we can do
          // some checks before. However, `transformPasted` only runs when
          // editor content is pasted - not external content.
          handleDOMEvents: {
            // only create new ids for dropped content while holding `alt`
            // or content is dragged from another editor
            drop: (n, o) => {
              let r;
              return e !== n.dom.parentElement || ((r = o.dataTransfer) === null || r === void 0 ? void 0 : r.effectAllowed) === "copy" ? t = !0 : t = !1, e = null, !1;
            },
            // always create new ids on pasted content
            paste: () => (t = !0, !1)
          },
          // we’ll remove ids for every pasted node
          // so we can create a new one within `appendTransaction`
          transformPasted: (n) => {
            if (!t)
              return n;
            const { types: o, attributeName: r } = this.options, s = (a) => {
              const i = [];
              return a.forEach((c) => {
                if (c.isText) {
                  i.push(c);
                  return;
                }
                if (!o.includes(c.type.name)) {
                  i.push(c.copy(s(c.content)));
                  return;
                }
                const l = c.type.create(
                  {
                    ...c.attrs,
                    [r]: null
                  },
                  s(c.content),
                  c.marks
                );
                i.push(l);
              }), W.from(i);
            };
            return t = !1, new ke(
              s(n.content),
              n.openStart,
              n.openEnd
            );
          }
        }
      })
    ];
  }
});
function Oe(e) {
  return e.type === "link";
}
function et(e) {
  return typeof e != "string" && e.type === "link";
}
function I(e) {
  return typeof e != "string" && e.type === "text";
}
class J extends Error {
  constructor(t) {
    super(`Unreachable case: ${t}`);
  }
}
function Jo(e, t = !0) {
  const { "data-test": n, ...o } = e;
  if (Object.keys(o).length > 0 && t)
    throw new Error("Object must be empty " + JSON.stringify(e));
}
function j(e) {
  return "doc" in e ? e.doc.type.schema : e.type.schema;
}
function tt(e) {
  return e.cached.blockNoteEditor;
}
function ye(e) {
  return tt(e).schema;
}
function we(e) {
  return ye(e).blockSchema;
}
function ve(e) {
  return ye(e).inlineContentSchema;
}
function F(e) {
  return ye(e).styleSchema;
}
function Ee(e) {
  return tt(e).blockCache;
}
function Gt(e, t, n) {
  var s, a;
  const o = {
    type: "tableContent",
    columnWidths: [],
    headerRows: void 0,
    headerCols: void 0,
    rows: []
  }, r = [];
  e.content.forEach((i, c, l) => {
    const d = {
      cells: []
    };
    l === 0 && i.content.forEach((u) => {
      let p = u.attrs.colwidth;
      p == null && (p = new Array(u.attrs.colspan ?? 1).fill(void 0)), o.columnWidths.push(...p);
    }), d.cells = i.content.content.map((u, p) => (r[l] || (r[l] = []), r[l][p] = u.type.name === "tableHeader", {
      type: "tableCell",
      content: u.content.content.map(
        (h) => xe(h, t, n)
      ).reduce(
        (h, k) => {
          if (!h.length)
            return k;
          const m = h[h.length - 1], b = k[0];
          return b && I(m) && I(b) && JSON.stringify(m.styles) === JSON.stringify(b.styles) ? (m.text += `
` + b.text, h.push(...k.slice(1)), h) : (h.push(...k), h);
        },
        []
      ),
      props: {
        colspan: u.attrs.colspan,
        rowspan: u.attrs.rowspan,
        backgroundColor: u.attrs.backgroundColor,
        textColor: u.attrs.textColor,
        textAlignment: u.attrs.textAlignment
      }
    })), o.rows.push(d);
  });
  for (let i = 0; i < r.length; i++)
    (s = r[i]) != null && s.every((c) => c) && (o.headerRows = (o.headerRows ?? 0) + 1);
  for (let i = 0; i < ((a = r[0]) == null ? void 0 : a.length); i++)
    r != null && r.every((c) => c[i]) && (o.headerCols = (o.headerCols ?? 0) + 1);
  return o;
}
function xe(e, t, n) {
  const o = [];
  let r;
  return e.content.forEach((s) => {
    if (s.type.name === "hardBreak") {
      if (r)
        if (I(r))
          r.text += `
`;
        else if (Oe(r))
          r.content[r.content.length - 1].text += `
`;
        else
          throw new Error("unexpected");
      else
        r = {
          type: "text",
          text: `
`,
          styles: {}
        };
      return;
    }
    if (s.type.name !== "link" && s.type.name !== "text") {
      if (!t[s.type.name]) {
        console.warn("unrecognized inline content type", s.type.name);
        return;
      }
      r && (o.push(r), r = void 0), o.push(
        Zt(s, t, n)
      );
      return;
    }
    const a = {};
    let i;
    for (const c of s.marks)
      if (c.type.name === "link")
        i = c;
      else {
        const l = n[c.type.name];
        if (!l) {
          if (c.type.spec.blocknoteIgnore)
            continue;
          throw new Error(`style ${c.type.name} not found in styleSchema`);
        }
        if (l.propSchema === "boolean")
          a[l.type] = !0;
        else if (l.propSchema === "string")
          a[l.type] = c.attrs.stringValue;
        else
          throw new J(l.propSchema);
      }
    r ? I(r) ? i ? (o.push(r), r = {
      type: "link",
      href: i.attrs.href,
      content: [
        {
          type: "text",
          text: s.textContent,
          styles: a
        }
      ]
    }) : JSON.stringify(r.styles) === JSON.stringify(a) ? r.text += s.textContent : (o.push(r), r = {
      type: "text",
      text: s.textContent,
      styles: a
    }) : Oe(r) && (i ? r.href === i.attrs.href ? JSON.stringify(
      r.content[r.content.length - 1].styles
    ) === JSON.stringify(a) ? r.content[r.content.length - 1].text += s.textContent : r.content.push({
      type: "text",
      text: s.textContent,
      styles: a
    }) : (o.push(r), r = {
      type: "link",
      href: i.attrs.href,
      content: [
        {
          type: "text",
          text: s.textContent,
          styles: a
        }
      ]
    }) : (o.push(r), r = {
      type: "text",
      text: s.textContent,
      styles: a
    })) : i ? r = {
      type: "link",
      href: i.attrs.href,
      content: [
        {
          type: "text",
          text: s.textContent,
          styles: a
        }
      ]
    } : r = {
      type: "text",
      text: s.textContent,
      styles: a
    };
  }), r && o.push(r), o;
}
function Zt(e, t, n) {
  if (e.type.name === "text" || e.type.name === "link")
    throw new Error("unexpected");
  const o = {}, r = t[e.type.name];
  for (const [i, c] of Object.entries(e.attrs)) {
    if (!r)
      throw Error("ic node is of an unrecognized type: " + e.type.name);
    const l = r.propSchema;
    i in l && (o[i] = c);
  }
  let s;
  return r.content === "styled" ? s = xe(
    e,
    t,
    n
  ) : s = void 0, {
    type: e.type.name,
    props: o,
    content: s
  };
}
function K(e, t = j(e), n = we(t), o = ve(t), r = F(t), s = Ee(t)) {
  var k;
  if (!e.type.isInGroup("bnBlock"))
    throw Error("Node should be a bnBlock, but is instead: " + e.type.name);
  const a = s == null ? void 0 : s.get(e);
  if (a)
    return a;
  const i = Ce(e, 0);
  let c = i.bnBlock.node.attrs.id;
  c === null && (c = Ye.options.generateID());
  const l = n[i.blockNoteType];
  if (!l)
    throw Error("Block is of an unrecognized type: " + i.blockNoteType);
  const d = {};
  for (const [m, b] of Object.entries({
    ...e.attrs,
    ...i.isBlockContainer ? i.blockContent.node.attrs : {}
  })) {
    const y = l.propSchema;
    m in y && !(y[m].default === void 0 && b === void 0) && (d[m] = b);
  }
  const u = n[i.blockNoteType], p = [];
  (k = i.childContainer) == null || k.node.forEach((m) => {
    p.push(
      K(
        m,
        t,
        n,
        o,
        r,
        s
      )
    );
  });
  let f;
  if (u.content === "inline") {
    if (!i.isBlockContainer)
      throw new Error("impossible");
    f = xe(
      i.blockContent.node,
      o,
      r
    );
  } else if (u.content === "table") {
    if (!i.isBlockContainer)
      throw new Error("impossible");
    f = Gt(
      i.blockContent.node,
      o,
      r
    );
  } else if (u.content === "none")
    f = void 0;
  else
    throw new J(u.content);
  const h = {
    id: c,
    type: u.type,
    props: d,
    content: f,
    children: p
  };
  return s == null || s.set(e, h), h;
}
function Ko(e, t = j(e), n = we(t), o = ve(t), r = F(t), s = Ee(t)) {
  const a = [];
  return e.firstChild.descendants((i) => (a.push(
    K(
      i,
      t,
      n,
      o,
      r,
      s
    )
  ), !1)), a;
}
function Qo(e, t, n = we(t), o = ve(t), r = F(t), s = Ee(t)) {
  function a(i, c, l) {
    if (i.type.name !== "blockGroup")
      throw new Error("unexpected");
    const d = [];
    let u, p;
    return i.forEach((f, h, k) => {
      if (f.type.name !== "blockContainer")
        throw new Error("unexpected");
      if (f.childCount === 0)
        return;
      if (f.childCount === 0 || f.childCount > 2)
        throw new Error(
          "unexpected, blockContainer.childCount: " + f.childCount
        );
      const m = k === 0, b = k === i.childCount - 1;
      if (f.firstChild.type.name === "blockGroup") {
        if (!m)
          throw new Error("unexpected");
        const S = a(
          f.firstChild,
          Math.max(0, c - 1),
          b ? Math.max(0, l - 1) : 0
        );
        u = S.blockCutAtStart, b && (p = S.blockCutAtEnd), d.push(...S.blocks);
        return;
      }
      const y = K(
        f,
        t,
        n,
        o,
        r,
        s
      ), g = f.childCount > 1 ? f.child(1) : void 0;
      let v = [];
      if (g) {
        const S = a(
          g,
          0,
          // TODO: can this be anything other than 0?
          b ? Math.max(0, l - 1) : 0
        );
        v = S.blocks, b && (p = S.blockCutAtEnd);
      }
      b && !g && l > 1 && (p = y.id), m && c > 1 && (u = y.id), d.push({
        ...y,
        children: v
      });
    }), { blocks: d, blockCutAtStart: u, blockCutAtEnd: p };
  }
  if (e.content.childCount === 0)
    return {
      blocks: [],
      blockCutAtStart: void 0,
      blockCutAtEnd: void 0
    };
  if (e.content.childCount !== 1)
    throw new Error(
      "slice must be a single block, did you forget includeParents=true?"
    );
  return a(
    e.content.firstChild,
    Math.max(e.openStart - 1, 0),
    Math.max(e.openEnd - 1, 0)
  );
}
function Xt(e, t) {
  let n, o;
  if (t.firstChild.descendants((r, s) => n ? !1 : !Jt(r) || r.attrs.id !== e ? !0 : (n = r, o = s + 1, !1)), !(n === void 0 || o === void 0))
    return {
      node: n,
      posBeforeNode: o
    };
}
function Jt(e) {
  return e.type.isInGroup("bnBlock");
}
function Q(e) {
  return typeof e == "string";
}
function oe(e) {
  return !!e && typeof e == "object" && "id" in e && !("offset" in e);
}
function _(e) {
  return !!e && typeof e == "object" && "offset" in e && typeof e.offset == "number" && "id" in e && Q(e.id);
}
function re(e) {
  return !!e && typeof e == "object" && "anchor" in e && _(e.anchor) && "head" in e && _(e.head);
}
function Kt(e) {
  if (Q(e))
    return [e, e];
  if (oe(e))
    return [e.id, e.id];
  if (_(e))
    return [e.id, e.id];
  if (re(e))
    return [e.anchor.id, e.head.id];
  throw new Error("Invalid location", { cause: { location: e } });
}
function Yo(e) {
  if (Q(e) || oe(e))
    return !0;
  if (_(e))
    return e.offset === -1;
  if (re(e))
    return e.anchor.offset === -1 && e.head.offset === -1 && e.anchor.id === e.head.id;
  throw new Error("Invalid location", { cause: { location: e } });
}
function Qt(e) {
  if (Q(e) && (e = {
    id: e,
    offset: -1
  }), oe(e) && (e = {
    id: e.id,
    offset: -1
  }), _(e))
    return {
      anchor: e,
      head: e
    };
  if (re(e))
    return e;
  throw new Error("Invalid location type", { cause: { location: e } });
}
function er(e, t) {
  const n = Qt(e);
  if (t === void 0 && n.anchor.id !== n.head.id)
    throw new Error("Invalid location, must be a single block", {
      cause: { location: e }
    });
  return t === "end" ? n.head.id : n.anchor.id;
}
function tr(e, t) {
  if (Q(t))
    return ee(e, t);
  if (oe(t))
    return ee(e, t.id);
  if (_(t))
    return de(e, t);
  if (re(t))
    return Yt(e, t);
  throw new Error("Invalid location type", { cause: { location: t } });
}
function ee(e, t) {
  const n = Xt(t, e);
  if (!n)
    throw new Error(`Block with ID ${t} not found`);
  const o = D(n);
  return {
    anchor: o.bnBlock.beforePos,
    head: o.bnBlock.afterPos - 1
  };
}
function de(e, t) {
  const n = ee(e, t.id);
  if (t.offset === -1)
    return {
      anchor: n.anchor,
      head: n.head
    };
  const o = n.anchor + t.offset + 2;
  if (o > n.head)
    throw new Error(
      `Invalid offset: ${t.offset} exceeds block length ${n.head - n.anchor}`
    );
  return {
    anchor: o,
    head: o
  };
}
function Yt(e, t) {
  const n = de(e, t.anchor), o = de(e, t.head), r = Math.min(n.anchor, n.head), s = Math.max(n.anchor, n.head), a = Math.min(o.anchor, o.head), i = Math.max(o.anchor, o.head);
  return s < a ? {
    anchor: r,
    head: i
  } : i < r ? {
    anchor: s,
    head: a
  } : {
    anchor: Math.min(r, a),
    head: Math.max(s, i)
  };
}
function nr(e, t) {
  var a, i, c;
  const n = H(e, t.anchor), o = t.anchor === t.head ? n : H(e, t.head), r = Math.min(
    Math.max(t.anchor - n.posBeforeNode - 1, -1),
    ((a = n.node.firstChild) == null ? void 0 : a.nodeSize) ?? Number.MAX_SAFE_INTEGER
  ), s = Math.min(
    Math.max(t.head - o.posBeforeNode - 1, -1),
    ((i = o.node.firstChild) == null ? void 0 : i.nodeSize) ?? Number.MAX_SAFE_INTEGER
  );
  if (n.node === o.node) {
    if (r === -1 && s === (((c = o.node.firstChild) == null ? void 0 : c.nodeSize) ?? 0))
      return {
        id: n.node.attrs.id,
        offset: -1
      };
    if (s === r)
      return {
        id: n.node.attrs.id,
        offset: s - 1
      };
  }
  return {
    anchor: {
      id: n.node.attrs.id,
      offset: r - 1
    },
    head: {
      id: o.node.attrs.id,
      offset: s - 1
    }
  };
}
function nt(e, t) {
  const [n, o] = Kt(t);
  if (n !== o)
    throw new Error(
      "Block is ambiguous, given a range of blocks to get the start of: " + JSON.stringify(t),
      { cause: { location: t } }
    );
  return ee(e, n);
}
function en(e, t) {
  return nt(e, t).anchor;
}
function or(e, t) {
  return nt(e, t).head;
}
function pe(e) {
  var t, n, o, r, s;
  return Se(e) ? { ...e } : q(e) ? {
    type: "tableCell",
    content: [].concat(e.content),
    props: {
      backgroundColor: ((t = e.props) == null ? void 0 : t.backgroundColor) ?? "default",
      textColor: ((n = e.props) == null ? void 0 : n.textColor) ?? "default",
      textAlignment: ((o = e.props) == null ? void 0 : o.textAlignment) ?? "left",
      colspan: ((r = e.props) == null ? void 0 : r.colspan) ?? 1,
      rowspan: ((s = e.props) == null ? void 0 : s.rowspan) ?? 1
    }
  } : {
    type: "tableCell",
    content: [].concat(e),
    props: {
      backgroundColor: "default",
      textColor: "default",
      textAlignment: "left",
      colspan: 1,
      rowspan: 1
    }
  };
}
function q(e) {
  return e != null && typeof e != "string" && !Array.isArray(e) && e.type === "tableCell";
}
function Se(e) {
  return q(e) && e.props !== void 0 && e.content !== void 0;
}
function G(e) {
  return Se(e) ? e.props.colspan ?? 1 : 1;
}
function fe(e) {
  return Se(e) ? e.props.rowspan ?? 1 : 1;
}
const tn = () => typeof navigator < "u" && (/Mac/.test(navigator.platform) || /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent));
function L(e, t = "Ctrl") {
  return tn() ? e.replace("Mod", "⌘") : e.replace("Mod", t);
}
function Z(...e) {
  return [
    // Converts to & from set to remove duplicates.
    ...new Set(
      e.filter((t) => t).join(" ").split(" ")
    )
  ].join(" ");
}
const rr = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
function nn(e, t, n, o) {
  const r = document.createElement("div");
  r.className = Z(
    "bn-block-content",
    n.class
  ), r.setAttribute("data-content-type", e);
  for (const [a, i] of Object.entries(n))
    a !== "class" && r.setAttribute(a, i);
  const s = document.createElement(t);
  s.className = Z(
    "bn-inline-content",
    o.class
  );
  for (const [a, i] of Object.entries(
    o
  ))
    a !== "class" && s.setAttribute(a, i);
  return r.appendChild(s), {
    dom: r,
    contentDOM: s
  };
}
const He = (e, t) => {
  let n = se(e, t.pmSchema);
  n.type.name === "blockContainer" && (n = n.firstChild);
  const o = t.pmSchema.nodes[n.type.name].spec.toDOM;
  if (o === void 0)
    throw new Error(
      "This block has no default HTML serialization as its corresponding TipTap node doesn't implement `renderHTML`."
    );
  const r = o(n);
  if (typeof r != "object" || !("dom" in r))
    throw new Error(
      "Cannot use this block's default HTML serialization as its corresponding TipTap node's `renderHTML` function does not return an object with the `dom` property."
    );
  return r;
};
function on(e, t = "<br>") {
  const n = e.querySelectorAll("p");
  if (n.length > 1) {
    const o = n[0];
    for (let r = 1; r < n.length; r++) {
      const s = n[r];
      o.innerHTML += t + s.innerHTML, s.remove();
    }
  }
}
function te(e) {
  return "data-" + e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function sr(e) {
  const t = e.split("/");
  return !t.length || // invalid?
  t[t.length - 1] === "" ? e : t[t.length - 1];
}
function ar(e) {
  var n;
  const t = [
    "mp4",
    "webm",
    "ogg",
    "mov",
    "mkv",
    "flv",
    "avi",
    "wmv",
    "m4v"
  ];
  try {
    const r = ((n = new URL(e).pathname.split(".").pop()) == null ? void 0 : n.toLowerCase()) || "";
    return t.includes(r);
  } catch {
    return !1;
  }
}
function rn(e) {
  const t = {};
  return Object.entries(e).forEach(([n, o]) => {
    t[n] = {
      default: o.default,
      keepOnSplit: !0,
      // Props are displayed in kebab-case as HTML attributes. If a prop's
      // value is the same as its default, we don't display an HTML
      // attribute for it.
      parseHTML: (r) => {
        const s = r.getAttribute(te(n));
        if (s === null)
          return null;
        if (o.default === void 0 && o.type === "boolean" || o.default !== void 0 && typeof o.default == "boolean")
          return s === "true" ? !0 : s === "false" ? !1 : null;
        if (o.default === void 0 && o.type === "number" || o.default !== void 0 && typeof o.default == "number") {
          const a = parseFloat(s);
          return !Number.isNaN(a) && Number.isFinite(a) ? a : null;
        }
        return s;
      },
      renderHTML: (r) => r[n] !== o.default ? {
        [te(n)]: r[n]
      } : {}
    };
  }), t;
}
function sn(e, t, n, o) {
  const r = e();
  if (r === void 0)
    throw new Error("Cannot find node position");
  const a = n.state.doc.resolve(r).node().attrs.id;
  if (!a)
    throw new Error("Block doesn't have id");
  const i = t.getBlock(a);
  if (i.type !== o)
    throw new Error("Block type does not match");
  return i;
}
function he(e, t, n, o, r = !1, s) {
  const a = document.createElement("div");
  if (s !== void 0)
    for (const [i, c] of Object.entries(s))
      i !== "class" && a.setAttribute(i, c);
  a.className = Z(
    "bn-block-content",
    (s == null ? void 0 : s.class) || ""
  ), a.setAttribute("data-content-type", t);
  for (const [i, c] of Object.entries(n)) {
    const d = o[i].default;
    c !== d && a.setAttribute(te(i), c);
  }
  return r && a.setAttribute("data-file-block", ""), a.appendChild(e.dom), e.contentDOM && (e.contentDOM.className = Z(
    "bn-inline-content",
    e.contentDOM.className
  )), {
    ...e,
    dom: a
  };
}
function an(e, t, n) {
  return {
    config: {
      type: e.type,
      content: e.content,
      propSchema: t
    },
    implementation: {
      node: e.node,
      render: He,
      toExternalHTML: He
    },
    extensions: n
  };
}
function cn(e, t) {
  e.stopEvent = (n) => (n.type === "mousedown" && setTimeout(() => {
    t.view.dom.blur();
  }, 10), !0);
}
function ln(e, t) {
  const n = [
    {
      tag: "[data-content-type=" + e.type + "]",
      contentElement: ".bn-inline-content"
    }
  ];
  return t.parse && n.push({
    tag: "*",
    getAttrs(o) {
      var s;
      if (typeof o == "string")
        return !1;
      const r = (s = t.parse) == null ? void 0 : s.call(t, o);
      return r === void 0 ? !1 : r;
    },
    getContent: e.content === "inline" || e.content === "none" ? (o, r) => {
      var s;
      if (t.parseContent)
        return t.parseContent({
          el: o,
          schema: r
        });
      if (e.content === "inline") {
        const i = o.cloneNode(!0);
        return on(
          i,
          (s = t.meta) != null && s.code ? `
` : "<br>"
        ), ne.fromSchema(r).parse(i, {
          topNode: r.nodes.paragraph.create()
        }).content;
      }
      return W.empty;
    } : void 0
  }), n;
}
function un(e, t, n, o) {
  var s, a, i, c;
  const r = t.node || V.create({
    name: e.type,
    content: e.content === "inline" ? "inline*" : e.content === "none" ? "" : e.content,
    group: "blockContent",
    selectable: ((s = t.meta) == null ? void 0 : s.selectable) ?? !0,
    isolating: ((a = t.meta) == null ? void 0 : a.isolating) ?? !0,
    code: ((i = t.meta) == null ? void 0 : i.code) ?? !1,
    defining: ((c = t.meta) == null ? void 0 : c.defining) ?? !0,
    priority: o,
    addAttributes() {
      return rn(e.propSchema);
    },
    parseHTML() {
      return ln(e, t);
    },
    renderHTML({ HTMLAttributes: l }) {
      var u;
      const d = document.createElement("div");
      return he(
        {
          dom: d,
          contentDOM: e.content === "inline" ? d : void 0
        },
        e.type,
        {},
        e.propSchema,
        ((u = t.meta) == null ? void 0 : u.fileBlockAccept) !== void 0,
        l
      );
    },
    addNodeView() {
      return (l) => {
        var h, k;
        const d = this.options.editor, u = sn(
          l.getPos,
          d,
          this.editor,
          e.type
        ), p = ((h = this.options.domAttributes) == null ? void 0 : h.blockContent) || {}, f = t.render.call(
          { blockContentDOMAttributes: p, props: l, renderType: "nodeView" },
          u,
          d
        );
        return ((k = t.meta) == null ? void 0 : k.selectable) === !1 && cn(f, this.editor), f;
      };
    }
  });
  if (r.name !== e.type)
    throw new Error(
      "Node name does not match block type. This is a bug in BlockNote."
    );
  return {
    config: e,
    implementation: {
      ...t,
      node: r,
      render(l, d) {
        var p;
        const u = ((p = r.options.domAttributes) == null ? void 0 : p.blockContent) || {};
        return t.render.call(
          {
            blockContentDOMAttributes: u,
            props: void 0,
            renderType: "dom"
          },
          l,
          d
        );
      },
      // TODO: this should not have wrapInBlockStructure and generally be a lot simpler
      // post-processing in externalHTMLExporter should not be necessary
      toExternalHTML: (l, d) => {
        var p, f;
        const u = ((p = r.options.domAttributes) == null ? void 0 : p.blockContent) || {};
        return ((f = t.toExternalHTML) == null ? void 0 : f.call(
          { blockContentDOMAttributes: u },
          l,
          d
        )) ?? t.render.call(
          { blockContentDOMAttributes: u, renderType: "dom", props: void 0 },
          l,
          d
        );
      }
    },
    extensions: n
  };
}
function ir(e) {
  return e;
}
function M(e, t, n) {
  return (o = {}) => {
    const r = typeof e == "function" ? e(o) : e, s = typeof t == "function" ? t(o) : t, a = n ? typeof n == "function" ? n(o) : n : void 0;
    return {
      config: r,
      implementation: {
        ...s,
        // TODO: this should not have wrapInBlockStructure and generally be a lot simpler
        // post-processing in externalHTMLExporter should not be necessary
        toExternalHTML(i, c) {
          var d, u;
          const l = (d = s.toExternalHTML) == null ? void 0 : d.call(
            { blockContentDOMAttributes: this.blockContentDOMAttributes },
            i,
            c
          );
          if (l !== void 0)
            return he(
              l,
              i.type,
              i.props,
              r.propSchema,
              ((u = s.meta) == null ? void 0 : u.fileBlockAccept) !== void 0
            );
        },
        render(i, c) {
          var u;
          const l = s.render.call(
            {
              blockContentDOMAttributes: this.blockContentDOMAttributes,
              renderType: this.renderType,
              props: this.props
            },
            i,
            c
          );
          return he(
            l,
            i.type,
            i.props,
            r.propSchema,
            ((u = s.meta) == null ? void 0 : u.fileBlockAccept) !== void 0,
            this.blockContentDOMAttributes
          );
        }
      },
      extensions: a
    };
  };
}
function cr(e, t, n, o) {
  return e.dom.setAttribute("data-inline-content-type", t), Object.entries(n).filter(([r, s]) => {
    const a = o[r];
    return s !== a.default;
  }).map(([r, s]) => [te(r), s]).forEach(([r, s]) => e.dom.setAttribute(r, s)), e.contentDOM && e.contentDOM.setAttribute("data-editable", ""), e;
}
function lr(e) {
  return {
    Backspace: ({ editor: t }) => {
      const n = t.state.selection.$from;
      return t.state.selection.empty && n.node().type.name === e.type && n.parentOffset === 0;
    }
  };
}
function dn(e, t) {
  return {
    config: e,
    implementation: t
  };
}
function ur(e, t, n) {
  return dn(
    {
      type: e.name,
      propSchema: t,
      content: e.config.content === "inline*" ? "styled" : "none"
    },
    {
      ...n,
      node: e
    }
  );
}
function ot(e) {
  return Object.fromEntries(
    Object.entries(e).map(([t, n]) => [t, n.config])
  );
}
function pn(e) {
  return e === "boolean" ? {} : {
    stringValue: {
      default: void 0,
      keepOnSplit: !0,
      parseHTML: (t) => t.getAttribute("data-value"),
      renderHTML: (t) => t.stringValue !== void 0 ? {
        "data-value": t.stringValue
      } : {}
    }
  };
}
function Y(e, t, n, o) {
  return e.dom.setAttribute("data-style-type", t), o === "string" && e.dom.setAttribute("data-value", n), e.contentDOM && e.contentDOM.setAttribute("data-editable", ""), e;
}
function rt(e, t) {
  return {
    config: e,
    implementation: t
  };
}
function z(e, t) {
  return rt(
    {
      type: e.name,
      propSchema: t
    },
    {
      mark: e,
      render(n, o) {
        const r = o.pmSchema.marks[e.name].spec.toDOM;
        if (r === void 0)
          throw new Error(
            "This block has no default HTML serialization as its corresponding TipTap node doesn't implement `renderHTML`."
          );
        const s = o.pmSchema.mark(e.name, {
          stringValue: n
        }), a = Ie.renderSpec(
          document,
          r(s, !0)
        );
        if (typeof a != "object" || !("dom" in a))
          throw new Error(
            "Cannot use this block's default HTML serialization as its corresponding TipTap mark's `renderHTML` function does not return an object with the `dom` property."
          );
        return a;
      },
      toExternalHTML(n, o) {
        const r = o.pmSchema.marks[e.name].spec.toDOM;
        if (r === void 0)
          throw new Error(
            "This block has no default HTML serialization as its corresponding TipTap node doesn't implement `renderHTML`."
          );
        const s = o.pmSchema.mark(e.name, {
          stringValue: n
        }), a = Ie.renderSpec(
          document,
          r(s, !0)
        );
        if (typeof a != "object" || !("dom" in a))
          throw new Error(
            "Cannot use this block's default HTML serialization as its corresponding TipTap mark's `renderHTML` function does not return an object with the `dom` property."
          );
        return a;
      }
    }
  );
}
function st(e) {
  return Object.fromEntries(
    Object.entries(e).map(([t, n]) => [t, n.config])
  );
}
function fn(e, t) {
  const n = [
    {
      tag: `[data-style-type="${e.type}"]`,
      contentElement: (o) => {
        const r = o;
        return r.matches("[data-editable]") ? r : r.querySelector("[data-editable]") || r;
      }
    }
  ];
  return t && n.push({
    tag: "*",
    // By default, styles can overlap each other, so the rules should not
    // completely consume the element they parse (which can have multiple
    // styles).
    consuming: !1,
    getAttrs(o) {
      if (typeof o == "string")
        return !1;
      const r = t == null ? void 0 : t(o);
      return r === void 0 ? !1 : { stringValue: r };
    }
  }), n;
}
function at(e, t) {
  const n = Ht.create({
    name: e.type,
    addAttributes() {
      return pn(e.propSchema);
    },
    parseHTML() {
      return fn(e, t.parse);
    },
    renderHTML({ mark: o }) {
      const r = (t.toExternalHTML || t.render)(o.attrs.stringValue);
      return Y(
        r,
        e.type,
        o.attrs.stringValue,
        e.propSchema
      );
    },
    addMarkView() {
      return ({ mark: o }) => {
        const r = t.render(o.attrs.stringValue);
        return Y(
          r,
          e.type,
          o.attrs.stringValue,
          e.propSchema
        );
      };
    }
  });
  return rt(e, {
    ...t,
    mark: n,
    render: (o) => {
      const r = t.render(o);
      return Y(
        r,
        e.type,
        o,
        e.propSchema
      );
    },
    toExternalHTML: (o) => {
      const r = (t.toExternalHTML || t.render)(o);
      return Y(
        r,
        e.type,
        o,
        e.propSchema
      );
    }
  });
}
function hn(e) {
  const t = gn(e);
  let { roots: n, nonRoots: o } = De(t);
  const r = [];
  for (; n.size; ) {
    r.push(n);
    const s = /* @__PURE__ */ new Set();
    for (const a of n) {
      const i = e.get(a);
      if (i)
        for (const c of i) {
          const l = t.get(c);
          if (l === void 0)
            continue;
          const d = l - 1;
          t.set(c, d), d === 0 && s.add(c);
        }
    }
    n = s;
  }
  if (o = De(t).nonRoots, o.size)
    throw new Error(
      `Cycle(s) detected; toposort only works on acyclic graphs. Cyclic nodes: ${Array.from(o).join(", ")}`
    );
  return r;
}
function mn(e) {
  const t = bn(e);
  return hn(t);
}
function gn(e) {
  const t = /* @__PURE__ */ new Map();
  for (const [n, o] of e.entries()) {
    t.has(n) || t.set(n, 0);
    for (const r of o) {
      const s = t.get(r) ?? 0;
      t.set(r, s + 1);
    }
  }
  return t;
}
function De(e) {
  const t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set();
  for (const [o, r] of e.entries())
    r === 0 ? t.add(o) : n.add(o);
  return { roots: t, nonRoots: n };
}
function bn(e) {
  const t = /* @__PURE__ */ new Map();
  for (const [n, o] of e.entries()) {
    t.has(n) || t.set(n, /* @__PURE__ */ new Set());
    for (const r of o)
      t.has(r) || t.set(r, /* @__PURE__ */ new Set()), t.get(r).add(n);
  }
  return t;
}
function kn() {
  return /* @__PURE__ */ new Map();
}
function _e(e) {
  return e && Object.fromEntries(
    Object.entries(e).filter(([, t]) => t !== void 0)
  );
}
class Cn {
  constructor(t) {
    // Helper so that you can use typeof schema.BlockNoteEditor
    x(this, "BlockNoteEditor", "only for types");
    x(this, "Block", "only for types");
    x(this, "PartialBlock", "only for types");
    x(this, "inlineContentSpecs");
    x(this, "styleSpecs");
    x(this, "blockSpecs");
    x(this, "blockSchema");
    x(this, "inlineContentSchema");
    x(this, "styleSchema");
    this.opts = t;
    const {
      blockSpecs: n,
      inlineContentSpecs: o,
      styleSpecs: r,
      blockSchema: s,
      inlineContentSchema: a,
      styleSchema: i
    } = this.init();
    this.blockSpecs = n, this.styleSpecs = r, this.styleSchema = i, this.inlineContentSpecs = o, this.blockSchema = s, this.inlineContentSchema = a;
  }
  init() {
    var l;
    const t = kn(), n = /* @__PURE__ */ new Set();
    t.set("default", n);
    for (const [d, u] of Object.entries({
      ...this.opts.blockSpecs,
      ...this.opts.inlineContentSpecs,
      ...this.opts.styleSpecs
    }))
      (l = u.implementation) != null && l.runsBefore ? t.set(d, new Set(u.implementation.runsBefore)) : n.add(d);
    const o = mn(t), r = o.findIndex((d) => d.has("default")), s = (d) => 91 + (o.findIndex((p) => p.has(d)) + r) * 10, a = Object.fromEntries(
      Object.entries(this.opts.blockSpecs).map(([d, u]) => [
        d,
        un(
          u.config,
          u.implementation,
          u.extensions,
          s(d)
        )
      ])
    ), i = Object.fromEntries(
      Object.entries(this.opts.inlineContentSpecs).map(
        ([d, u]) => {
          var p;
          return typeof u.config != "object" ? [d, u] : [
            d,
            {
              ...u,
              implementation: {
                ...u.implementation,
                node: (p = u.implementation) == null ? void 0 : p.node.extend({
                  priority: s(d)
                })
              }
            }
          ];
        }
      )
    ), c = Object.fromEntries(
      Object.entries(this.opts.styleSpecs).map(([d, u]) => {
        var p;
        return [
          d,
          {
            ...u,
            implementation: {
              ...u.implementation,
              mark: (p = u.implementation) == null ? void 0 : p.mark.extend({
                priority: s(d)
              })
            }
          }
        ];
      })
    );
    return {
      blockSpecs: a,
      blockSchema: Object.fromEntries(
        Object.entries(a).map(([d, u]) => [d, u.config])
      ),
      inlineContentSpecs: _e(i),
      styleSpecs: _e(c),
      inlineContentSchema: ot(
        i
      ),
      styleSchema: st(c)
    };
  }
  /**
   * Adds additional block specs to the current schema in a builder pattern.
   * This method allows extending the schema after it has been created.
   *
   * @param additionalBlockSpecs - Additional block specs to add to the schema
   * @returns The current schema instance for chaining
   */
  extend(t) {
    Object.assign(this.opts.blockSpecs, t.blockSpecs), Object.assign(this.opts.inlineContentSpecs, t.inlineContentSpecs), Object.assign(this.opts.styleSpecs, t.styleSpecs);
    const {
      blockSpecs: n,
      inlineContentSpecs: o,
      styleSpecs: r,
      blockSchema: s,
      inlineContentSchema: a,
      styleSchema: i
    } = this.init();
    return this.blockSpecs = n, this.styleSpecs = r, this.styleSchema = i, this.inlineContentSpecs = o, this.blockSchema = s, this.inlineContentSchema = a, this;
  }
}
function N(e) {
  const { height: t, width: n } = it(e), o = new Array(t).fill(!1).map(() => new Array(n).fill(null)), r = (s, a) => {
    for (let i = s; i < t; i++)
      for (let c = a; c < n; c++)
        if (!o[i][c])
          return { row: i, col: c };
    throw new Error(
      "Unable to create occupancy grid for table, no more available cells"
    );
  };
  for (let s = 0; s < e.content.rows.length; s++)
    for (let a = 0; a < e.content.rows[s].cells.length; a++) {
      const i = pe(e.content.rows[s].cells[a]), c = fe(i), l = G(i), { row: d, col: u } = r(s, a);
      for (let p = d; p < d + c; p++)
        for (let f = u; f < u + l; f++) {
          if (o[p][f])
            throw new Error(
              `Unable to create occupancy grid for table, cell at ${p},${f} is already occupied`
            );
          o[p][f] = {
            row: s,
            col: a,
            rowspan: c,
            colspan: l,
            cell: i
          };
        }
    }
  return o;
}
function X(e) {
  const t = /* @__PURE__ */ new Set();
  return e.map((n) => ({
    cells: n.map((o) => t.has(o.row + ":" + o.col) ? !1 : (t.add(o.row + ":" + o.col), o.cell)).filter((o) => o !== !1)
  }));
}
function P(e, t, n = N(t)) {
  for (let o = 0; o < n.length; o++)
    for (let r = 0; r < n[o].length; r++) {
      const s = n[o][r];
      if (s.row === e.row && s.col === e.col)
        return { row: o, col: r, cell: s.cell };
    }
  throw new Error(
    `Unable to resolve relative table cell indices for table, cell at ${e.row},${e.col} is not occupied`
  );
}
function it(e) {
  const t = e.content.rows.length;
  let n = 0;
  return e.content.rows.forEach((o) => {
    let r = 0;
    o.cells.forEach((s) => {
      r += G(s);
    }), n = Math.max(n, r);
  }), { height: t, width: n };
}
function ct(e, t, n = N(t)) {
  var r;
  const o = (r = n[e.row]) == null ? void 0 : r[e.col];
  if (o)
    return {
      row: o.row,
      col: o.col,
      cell: o.cell
    };
}
function yn(e, t) {
  var s;
  const n = N(e);
  if (t < 0 || t >= n.length)
    return [];
  let o = 0;
  for (let a = 0; a < t; a++) {
    const i = (s = n[o]) == null ? void 0 : s[0];
    if (!i)
      return [];
    o += i.rowspan;
  }
  const r = new Array(n[0].length).fill(!1).map((a, i) => ct(
    { row: o, col: i },
    e,
    n
  )).filter(
    (a) => a !== void 0
  );
  return r.filter((a, i) => r.findIndex((c) => c.row === a.row && c.col === a.col) === i);
}
function wn(e, t) {
  var s;
  const n = N(e);
  if (t < 0 || t >= n[0].length)
    return [];
  let o = 0;
  for (let a = 0; a < t; a++) {
    const i = (s = n[0]) == null ? void 0 : s[o];
    if (!i)
      return [];
    o += i.colspan;
  }
  const r = new Array(n.length).fill(!1).map((a, i) => ct(
    { row: i, col: o },
    e,
    n
  )).filter(
    (a) => a !== void 0
  );
  return r.filter((a, i) => r.findIndex((c) => c.row === a.row && c.col === a.col) === i);
}
function dr(e, t, n, o = N(e)) {
  const { col: r } = P(
    {
      row: 0,
      col: t
    },
    e,
    o
  ), { col: s } = P(
    {
      row: 0,
      col: n
    },
    e,
    o
  );
  return o.forEach((a) => {
    const [i] = a.splice(r, 1);
    a.splice(s, 0, i);
  }), X(o);
}
function pr(e, t, n, o = N(e)) {
  const { row: r } = P(
    {
      row: t,
      col: 0
    },
    e,
    o
  ), { row: s } = P(
    {
      row: n,
      col: 0
    },
    e,
    o
  ), [a] = o.splice(r, 1);
  return o.splice(s, 0, a), X(o);
}
function me(e) {
  return e ? q(e) ? me(e.content) : typeof e == "string" ? e.length === 0 : Array.isArray(e) ? e.every(
    (t) => typeof t == "string" ? t.length === 0 : I(t) ? t.text.length === 0 : et(t) ? typeof t.content == "string" ? t.content.length === 0 : t.content.every((n) => n.text.length === 0) : !1
  ) : !1 : !0;
}
function fr(e, t, n = N(e)) {
  if (t === "columns") {
    let s = 0;
    for (let a = n[0].length - 1; a >= 0 && n.every(
      (c) => me(c[a].cell) && c[a].colspan === 1
    ); a--)
      s++;
    for (let a = n.length - 1; a >= 0; a--) {
      const i = Math.max(
        n[a].length - s,
        1
      );
      n[a] = n[a].slice(0, i);
    }
    return X(n);
  }
  let o = 0;
  for (let s = n.length - 1; s >= 0 && n[s].every(
    (i) => me(i.cell) && i.rowspan === 1
  ); s--)
    o++;
  const r = Math.min(o, n.length - 1);
  return n.splice(n.length - r, r), X(n);
}
function hr(e, t, n, o = N(e)) {
  const { width: r, height: s } = it(e);
  if (t === "columns")
    o.forEach((a, i) => {
      if (n >= 0)
        for (let c = 0; c < n; c++)
          a.push({
            row: i,
            col: Math.max(...a.map((l) => l.col)) + 1,
            rowspan: 1,
            colspan: 1,
            cell: pe("")
          });
      else
        a.splice(r + n, -1 * n);
    });
  else if (n > 0)
    for (let a = 0; a < n; a++) {
      const i = new Array(r).fill(null).map((c, l) => ({
        row: s + a,
        col: l,
        rowspan: 1,
        colspan: 1,
        cell: pe("")
      }));
      o.push(i);
    }
  else n < 0 && o.splice(s + n, -1 * n);
  return X(o);
}
function mr(e, t, n) {
  const o = yn(e, n);
  if (!o.some((c) => fe(c.cell) > 1))
    return !0;
  let s = n, a = n;
  return o.forEach((c) => {
    const l = fe(c.cell);
    s = Math.max(s, c.row + l - 1), a = Math.min(a, c.row);
  }), t < n ? n === s : n === a;
}
function gr(e, t, n) {
  const o = wn(e, n);
  if (!o.some((c) => G(c.cell) > 1))
    return !0;
  let s = n, a = n;
  return o.forEach((c) => {
    const l = G(c.cell);
    s = Math.max(s, c.col + l - 1), a = Math.min(a, c.col);
  }), t < n ? n === s : n === a;
}
function br(e, t, n) {
  const o = P(e, n), r = P(t, n);
  return o.col === r.col;
}
function Re(e, t, n, o) {
  const r = [];
  for (const [a, i] of Object.entries(e.styles || {})) {
    const c = n[a];
    if (!c)
      throw new Error(`style ${a} not found in styleSchema`);
    if (c.propSchema === "boolean")
      i && r.push(t.mark(a));
    else if (c.propSchema === "string")
      i && r.push(t.mark(a, { stringValue: i }));
    else
      throw new J(c.propSchema);
  }
  return !o || !t.nodes[o].spec.code ? e.text.split(/(\n)/g).filter((a) => a.length > 0).map((a) => a === `
` ? t.nodes.hardBreak.createChecked() : t.text(a, r)) : e.text.length > 0 ? [t.text(e.text, r)] : [];
}
function vn(e, t, n) {
  const o = t.marks.link.create({
    href: e.href
  });
  return ge(e.content, t, n).map(
    (r) => {
      if (r.type.name === "text")
        return r.mark([...r.marks, o]);
      if (r.type.name === "hardBreak")
        return r;
      throw new Error("unexpected node type");
    }
  );
}
function ge(e, t, n, o) {
  const r = [];
  if (typeof e == "string")
    return r.push(
      ...Re(
        { text: e, styles: {} },
        t,
        n,
        o
      )
    ), r;
  for (const s of e)
    r.push(
      ...Re(s, t, n, o)
    );
  return r;
}
function R(e, t, n, o = F(t)) {
  const r = [];
  for (const s of e)
    typeof s == "string" ? r.push(
      ...ge(s, t, o, n)
    ) : et(s) ? r.push(...vn(s, t, o)) : I(s) ? r.push(
      ...ge([s], t, o, n)
    ) : r.push(
      ut(s, t, o)
    );
  return r;
}
function lt(e, t, n = F(t)) {
  const o = [], r = new Array(e.headerRows ?? 0).fill(!0), s = new Array(e.headerCols ?? 0).fill(!0), a = e.columnWidths ?? [];
  for (let i = 0; i < e.rows.length; i++) {
    const c = e.rows[i], l = [], d = r[i];
    for (let p = 0; p < c.cells.length; p++) {
      const f = c.cells[p], h = s[p], k = void 0;
      let m = null;
      const b = P(
        {
          row: i,
          col: p
        },
        { content: e }
      );
      let y = a[b.col] ? [a[b.col]] : null;
      if (f) if (typeof f == "string")
        m = t.text(f);
      else if (q(f)) {
        f.content && (m = R(
          f.content,
          t,
          "tableParagraph",
          n
        ));
        const v = G(f);
        v > 1 && (y = new Array(v).fill(!1).map((S, le) => a[b.col + le] ?? void 0));
      } else
        m = R(
          f,
          t,
          "tableParagraph",
          n
        );
      const g = t.nodes[h || d ? "tableHeader" : "tableCell"].createChecked(
        {
          ...q(f) ? f.props : {},
          colwidth: y
        },
        t.nodes.tableParagraph.createChecked(k, m)
      );
      l.push(g);
    }
    const u = t.nodes.tableRow.createChecked({}, l);
    o.push(u);
  }
  return o;
}
function ut(e, t, n) {
  let o, r = e.type;
  if (r === void 0 && (r = "paragraph"), !t.nodes[r])
    throw new Error(`node type ${r} not found in schema`);
  if (!e.content)
    o = t.nodes[r].createChecked(e.props);
  else if (typeof e.content == "string") {
    const s = R(
      [e.content],
      t,
      r,
      n
    );
    o = t.nodes[r].createChecked(e.props, s);
  } else if (Array.isArray(e.content)) {
    const s = R(
      e.content,
      t,
      r,
      n
    );
    o = t.nodes[r].createChecked(e.props, s);
  } else if (e.content.type === "tableContent") {
    const s = lt(e.content, t, n);
    o = t.nodes[r].createChecked(e.props, s);
  } else
    throw new J(e.content.type);
  return o;
}
function se(e, t, n = F(t)) {
  let o = e.id;
  o === void 0 && (o = Ye.options.generateID());
  const r = [];
  if (e.children)
    for (const a of e.children)
      r.push(se(a, t, n));
  if (!e.type || // can happen if block.type is not defined (this should create the default node)
  t.nodes[e.type].isInGroup("blockContent")) {
    const a = ut(
      e,
      t,
      n
    ), i = r.length > 0 ? t.nodes.blockGroup.createChecked({}, r) : void 0;
    return t.nodes.blockContainer.createChecked(
      {
        id: o,
        ...e.props
      },
      i ? [a, i] : a
    );
  } else {
    if (t.nodes[e.type].isInGroup("bnBlock"))
      return t.nodes[e.type].createChecked(
        {
          id: o,
          ...e.props
        },
        r
      );
    throw new Error(
      `block type ${e.type} doesn't match blockContent or bnBlock group`
    );
  }
}
const kr = (e, t) => ({
  tr: n,
  dispatch: o
}) => (o && Be(n, e, t), !0);
function Be(e, t, n, o, r) {
  const s = $t(e.doc.resolve(t));
  let a = null;
  s.blockNoteType === "table" && (a = xn(e));
  const i = j(e);
  if (o !== void 0 && r !== void 0 && o > r)
    throw new Error("Invalid replaceFromPos or replaceToPos");
  const c = i.nodes[s.blockNoteType], l = i.nodes[n.type || s.blockNoteType], d = l.isInGroup("bnBlock") ? l : i.nodes.blockContainer;
  if (s.isBlockContainer && l.isInGroup("blockContent")) {
    const u = o !== void 0 && o > s.blockContent.beforePos && o < s.blockContent.afterPos ? o - s.blockContent.beforePos - 1 : void 0, p = r !== void 0 && r > s.blockContent.beforePos && r < s.blockContent.afterPos ? r - s.blockContent.beforePos - 1 : void 0;
    Ve(n, e, s), En(
      n,
      e,
      c,
      l,
      s,
      u,
      p
    );
  } else if (!s.isBlockContainer && l.isInGroup("bnBlock"))
    Ve(n, e, s);
  else {
    const u = K(s.bnBlock.node);
    e.replaceWith(
      s.bnBlock.beforePos,
      s.bnBlock.afterPos,
      se(
        {
          children: u.children,
          // if no children are passed in, use existing children
          ...n
        },
        i
      )
    );
    return;
  }
  e.setNodeMarkup(s.bnBlock.beforePos, d, {
    ...s.bnBlock.node.attrs,
    ...n.props
  }), a && Sn(e, s, a);
}
function En(e, t, n, o, r, s, a) {
  const i = j(t);
  let c = "keep";
  if (e.content)
    if (typeof e.content == "string")
      c = R(
        [e.content],
        i,
        o.name
      );
    else if (Array.isArray(e.content))
      c = R(e.content, i, o.name);
    else if (e.content.type === "tableContent")
      c = lt(e.content, i);
    else
      throw new J(e.content.type);
  else
    n.spec.content === "" || o.spec.content !== n.spec.content && (c = []);
  if (c === "keep")
    t.setNodeMarkup(r.blockContent.beforePos, o, {
      ...r.blockContent.node.attrs,
      ...e.props
    });
  else if (s !== void 0 || a !== void 0) {
    t.setNodeMarkup(r.blockContent.beforePos, o, {
      ...r.blockContent.node.attrs,
      ...e.props
    });
    const l = r.blockContent.beforePos + 1 + (s ?? 0), d = r.blockContent.beforePos + 1 + (a ?? r.blockContent.node.content.size), u = t.doc.resolve(r.blockContent.beforePos).depth, p = t.doc.resolve(l).depth, f = t.doc.resolve(d).depth;
    t.replace(
      l,
      d,
      new ke(
        W.from(c),
        p - u - 1,
        f - u - 1
      )
    );
  } else
    t.replaceWith(
      r.blockContent.beforePos,
      r.blockContent.afterPos,
      o.createChecked(
        {
          ...r.blockContent.node.attrs,
          ...e.props
        },
        c
      )
    );
}
function Ve(e, t, n) {
  const o = j(t);
  if (e.children !== void 0 && e.children.length > 0) {
    const r = e.children.map((s) => se(s, o));
    if (n.childContainer)
      t.step(
        new jt(
          n.childContainer.beforePos + 1,
          n.childContainer.afterPos - 1,
          new ke(W.from(r), 0, 0)
        )
      );
    else {
      if (!n.isBlockContainer)
        throw new Error("impossible");
      t.insert(
        n.blockContent.afterPos,
        o.nodes.blockGroup.createChecked({}, r)
      );
    }
  }
}
function Cr(e, t, n, o, r) {
  const s = en(e.doc, t);
  Be(e, s, n, o, r);
  const { node: a } = H(e.doc, s);
  return K(a);
}
function xn(e) {
  const t = "selection" in e ? e.selection : null;
  if (!(t instanceof Ke))
    return null;
  const n = e.doc.resolve(t.head);
  let o = -1, r = -1;
  for (let m = n.depth; m >= 0; m--) {
    const b = n.node(m).type.name;
    if (o < 0 && (b === "tableCell" || b === "tableHeader") && (o = m), b === "table") {
      r = m;
      break;
    }
  }
  if (o < 0 || r < 0)
    return null;
  const s = n.before(o), a = n.before(r), i = e.doc.nodeAt(a);
  if (!i || i.type.name !== "table")
    return null;
  const c = qe.get(i), l = s - (a + 1), d = c.map.indexOf(l);
  if (d < 0)
    return null;
  const u = Math.floor(d / c.width), p = d % c.width, h = s + 1 + 1, k = Math.max(0, t.head - h);
  return { row: u, col: p, offset: k };
}
function Sn(e, t, n) {
  var m;
  if (t.blockNoteType !== "table")
    return !1;
  let o = -1;
  if (t.isBlockContainer)
    o = e.mapping.map(t.blockContent.beforePos);
  else {
    const b = e.mapping.map(t.bnBlock.beforePos), y = b + (((m = e.doc.nodeAt(b)) == null ? void 0 : m.nodeSize) || 0);
    e.doc.nodesBetween(b, y, (g, v) => g.type.name === "table" ? (o = v, !1) : !0);
  }
  const r = o >= 0 ? e.doc.nodeAt(o) : null;
  if (!r || r.type.name !== "table")
    return !1;
  const s = qe.get(r), a = Math.max(0, Math.min(n.row, s.height - 1)), i = Math.max(0, Math.min(n.col, s.width - 1)), c = a * s.width + i, l = s.map[c];
  if (l == null)
    return !1;
  const u = o + 1 + l + 1, p = e.doc.nodeAt(u), f = u + 1, h = p ? p.content.size : 0, k = f + Math.max(0, Math.min(n.offset, h));
  return "selection" in e && e.setSelection(Ke.create(e.doc, k)), !0;
}
const A = {
  gray: {
    text: "#9b9a97",
    background: "#ebeced"
  },
  brown: {
    text: "#64473a",
    background: "#e9e5e3"
  },
  red: {
    text: "#e03e3e",
    background: "#fbe4e4"
  },
  orange: {
    text: "#d9730d",
    background: "#f6e9d9"
  },
  yellow: {
    text: "#dfab01",
    background: "#fbf3db"
  },
  green: {
    text: "#4d6461",
    background: "#ddedea"
  },
  blue: {
    text: "#0b6e99",
    background: "#ddebf1"
  },
  purple: {
    text: "#6940a5",
    background: "#eae4f2"
  },
  pink: {
    text: "#ad1a72",
    background: "#f4dfeb"
  }
}, yr = {
  gray: {
    text: "#bebdb8",
    background: "#9b9a97"
  },
  brown: {
    text: "#8e6552",
    background: "#64473a"
  },
  red: {
    text: "#ec4040",
    background: "#be3434"
  },
  orange: {
    text: "#e3790d",
    background: "#b7600a"
  },
  yellow: {
    text: "#dfab01",
    background: "#b58b00"
  },
  green: {
    text: "#6b8b87",
    background: "#4d6461"
  },
  blue: {
    text: "#0e87bc",
    background: "#0b6e99"
  },
  purple: {
    text: "#8552d7",
    background: "#6940a5"
  },
  pink: {
    text: "#da208f",
    background: "#ad1a72"
  }
}, C = {
  backgroundColor: {
    default: "default"
  },
  textColor: {
    default: "default"
  },
  textAlignment: {
    default: "left",
    values: ["left", "center", "right", "justify"]
  }
}, B = (e) => {
  const t = {};
  return e.hasAttribute("data-background-color") ? t.backgroundColor = e.getAttribute("data-background-color") : e.style.backgroundColor && (t.backgroundColor = e.style.backgroundColor), e.hasAttribute("data-text-color") ? t.textColor = e.getAttribute("data-text-color") : e.style.color && (t.textColor = e.style.color), t.textAlignment = C.textAlignment.values.includes(
    e.style.textAlign
  ) ? e.style.textAlign : void 0, t;
}, O = (e, t) => {
  e.backgroundColor && e.backgroundColor !== C.backgroundColor.default && (t.style.backgroundColor = e.backgroundColor in A ? A[e.backgroundColor].background : e.backgroundColor), e.textColor && e.textColor !== C.textColor.default && (t.style.color = e.textColor in A ? A[e.textColor].text : e.textColor), e.textAlignment && e.textAlignment !== C.textAlignment.default && (t.style.textAlign = e.textAlignment);
}, wr = (e = "backgroundColor") => ({
  default: C.backgroundColor.default,
  parseHTML: (t) => t.hasAttribute("data-background-color") ? t.getAttribute("data-background-color") : t.style.backgroundColor ? t.style.backgroundColor : C.backgroundColor.default,
  renderHTML: (t) => t[e] === C.backgroundColor.default ? {} : {
    "data-background-color": t[e]
  }
}), vr = (e = "textColor") => ({
  default: C.textColor.default,
  parseHTML: (t) => t.hasAttribute("data-text-color") ? t.getAttribute("data-text-color") : t.style.color ? t.style.color : C.textColor.default,
  renderHTML: (t) => t[e] === C.textColor.default ? {} : {
    "data-text-color": t[e]
  }
}), Er = (e = "textAlignment") => ({
  default: C.textAlignment.default,
  parseHTML: (t) => t.hasAttribute("data-text-alignment") ? t.getAttribute("data-text-alignment") : t.style.textAlign ? t.style.textAlign : C.textAlignment.default,
  renderHTML: (t) => t[e] === C.textAlignment.default ? {} : {
    "data-text-alignment": t[e]
  }
}), ae = (e, t) => {
  const n = e.querySelector(
    t
  );
  if (!n)
    return;
  const o = e.querySelector("figcaption"), r = (o == null ? void 0 : o.textContent) ?? void 0;
  return { targetElement: n, caption: r };
}, Bn = (e, t, n) => {
  const o = document.createElement("div");
  o.className = "bn-add-file-button";
  const r = document.createElement("div");
  r.className = "bn-add-file-button-icon", n ? r.appendChild(n) : r.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M3 8L9.00319 2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8ZM10 4V9H5V20H19V4H10Z"></path></svg>', o.appendChild(r);
  const s = document.createElement("p");
  s.className = "bn-add-file-button-text", s.innerHTML = e.type in t.dictionary.file_blocks.add_button_text ? t.dictionary.file_blocks.add_button_text[e.type] : t.dictionary.file_blocks.add_button_text.file, o.appendChild(s);
  const a = (c) => {
    c.preventDefault();
  }, i = () => {
    t.transact(
      (c) => c.setMeta(t.filePanel.plugins[0], {
        block: e
      })
    );
  };
  return o.addEventListener(
    "mousedown",
    a,
    !0
  ), o.addEventListener("click", i, !0), {
    dom: o,
    destroy: () => {
      o.removeEventListener(
        "mousedown",
        a,
        !0
      ), o.removeEventListener(
        "click",
        i,
        !0
      );
    }
  };
}, Mn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M3 8L9.00319 2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8ZM10 4V9H5V20H19V4H10Z"></path></svg>', Tn = (e) => {
  const t = document.createElement("div");
  t.className = "bn-file-name-with-icon";
  const n = document.createElement("div");
  n.className = "bn-file-icon", n.innerHTML = Mn, t.appendChild(n);
  const o = document.createElement("p");
  return o.className = "bn-file-name", o.textContent = e.props.name, t.appendChild(o), {
    dom: t
  };
}, Me = (e, t, n, o) => {
  const r = document.createElement("div");
  if (r.className = "bn-file-block-content-wrapper", e.props.url === "") {
    const a = Bn(e, t, o);
    r.appendChild(a.dom);
    const i = t.onUploadStart((c) => {
      if (c === e.id) {
        r.removeChild(a.dom);
        const l = document.createElement("div");
        l.className = "bn-file-loading-preview", l.textContent = "Loading...", r.appendChild(l);
      }
    });
    return {
      dom: r,
      destroy: () => {
        i(), a.destroy();
      }
    };
  }
  const s = { dom: r };
  if (e.props.showPreview === !1 || !n) {
    const a = Tn(e);
    r.appendChild(a.dom), s.destroy = () => {
      var i;
      (i = a.destroy) == null || i.call(a);
    };
  } else
    r.appendChild(n.dom);
  if (e.props.caption) {
    const a = document.createElement("p");
    a.className = "bn-file-caption", a.textContent = e.props.caption, r.appendChild(a);
  }
  return s;
}, Te = (e, t) => {
  const n = document.createElement("figure"), o = document.createElement("figcaption");
  return o.textContent = t, n.appendChild(e), n.appendChild(o), { dom: n };
}, ie = (e, t) => {
  const n = document.createElement("div"), o = document.createElement("p");
  return o.textContent = t, n.appendChild(e), n.appendChild(o), {
    dom: n
  };
}, We = (e) => ({ url: e.src || void 0 }), Ln = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M2 16.0001H5.88889L11.1834 20.3319C11.2727 20.405 11.3846 20.4449 11.5 20.4449C11.7761 20.4449 12 20.2211 12 19.9449V4.05519C12 3.93977 11.9601 3.8279 11.887 3.73857C11.7121 3.52485 11.3971 3.49335 11.1834 3.66821L5.88889 8.00007H2C1.44772 8.00007 1 8.44778 1 9.00007V15.0001C1 15.5524 1.44772 16.0001 2 16.0001ZM23 12C23 15.292 21.5539 18.2463 19.2622 20.2622L17.8445 18.8444C19.7758 17.1937 21 14.7398 21 12C21 9.26016 19.7758 6.80629 17.8445 5.15557L19.2622 3.73779C21.5539 5.75368 23 8.70795 23 12ZM18 12C18 10.0883 17.106 8.38548 15.7133 7.28673L14.2842 8.71584C15.3213 9.43855 16 10.64 16 12C16 13.36 15.3213 14.5614 14.2842 15.2841L15.7133 16.7132C17.106 15.6145 18 13.9116 18 12Z"></path></svg>', An = (e) => ({
  type: "audio",
  propSchema: {
    backgroundColor: C.backgroundColor,
    // File name.
    name: {
      default: ""
    },
    // File url.
    url: {
      default: ""
    },
    // File caption.
    caption: {
      default: ""
    },
    showPreview: {
      default: !0
    }
  },
  content: "none"
}), Nn = (e = {}) => (t) => {
  if (t.tagName === "AUDIO") {
    if (t.closest("figure"))
      return;
    const { backgroundColor: n } = B(t);
    return {
      ...We(t),
      backgroundColor: n
    };
  }
  if (t.tagName === "FIGURE") {
    const n = ae(t, "audio");
    if (!n)
      return;
    const { targetElement: o, caption: r } = n, { backgroundColor: s } = B(t);
    return {
      ...We(o),
      backgroundColor: s,
      caption: r
    };
  }
}, In = (e = {}) => (t, n) => {
  const o = document.createElement("div");
  o.innerHTML = e.icon ?? Ln;
  const r = document.createElement("audio");
  return r.className = "bn-audio", n.resolveFileUrl ? n.resolveFileUrl(t.props.url).then((s) => {
    r.src = s;
  }) : r.src = t.props.url, r.controls = !0, r.contentEditable = "false", r.draggable = !1, Me(
    t,
    n,
    { dom: r },
    o.firstElementChild
  );
}, Pn = (e = {}) => (t, n) => {
  if (!t.props.url) {
    const r = document.createElement("p");
    return r.textContent = "Add audio", {
      dom: r
    };
  }
  let o;
  return t.props.showPreview ? (o = document.createElement("audio"), o.src = t.props.url) : (o = document.createElement("a"), o.href = t.props.url, o.textContent = t.props.name || t.props.url), t.props.caption ? t.props.showPreview ? Te(o, t.props.caption) : ie(o, t.props.caption) : {
    dom: o
  };
}, On = M(
  An,
  (e) => ({
    meta: {
      fileBlockAccept: ["audio/*"]
    },
    parse: Nn(e),
    render: In(e),
    toExternalHTML: Pn(e),
    runsBefore: ["file"]
  })
);
class Hn {
  constructor() {
    // eslint-disable-next-line @typescript-eslint/ban-types
    x(this, "callbacks", {});
  }
  on(t, n) {
    return this.callbacks[t] || (this.callbacks[t] = []), this.callbacks[t].push(n), () => this.off(t, n);
  }
  emit(t, ...n) {
    const o = this.callbacks[t];
    o && o.forEach((r) => r.apply(this, n));
  }
  off(t, n) {
    const o = this.callbacks[t];
    o && (n ? this.callbacks[t] = o.filter((r) => r !== n) : delete this.callbacks[t]);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
class Dn extends Hn {
  // eslint-disable-next-line
  constructor(...n) {
    super();
    x(this, "plugins", []);
    /**
     * Input rules for the block
     */
    x(this, "inputRules");
    /**
     * A mapping of a keyboard shortcut to a function that will be called when the shortcut is pressed
     *
     * The keys are in the format:
     * - Key names may be strings like `Shift-Ctrl-Enter`—a key identifier prefixed with zero or more modifiers
     * - Key identifiers are based on the strings that can appear in KeyEvent.key
     * - Use lowercase letters to refer to letter keys (or uppercase letters if you want shift to be held)
     * - You may use `Space` as an alias for the " " name
     * - Modifiers can be given in any order: `Shift-` (or `s-`), `Alt-` (or `a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or `Meta-`)
     * - For characters that are created by holding shift, the Shift- prefix is implied, and should not be added explicitly
     * - You can use Mod- as a shorthand for Cmd- on Mac and Ctrl- on other platforms
     *
     * @example
     * ```typescript
     * keyboardShortcuts: {
     *   "Mod-Enter": (ctx) => {  return true; },
     *   "Shift-Ctrl-Space": (ctx) => { return true; },
     *   "a": (ctx) => { return true; },
     *   "Space": (ctx) => { return true; }
     * }
     * ```
     */
    x(this, "keyboardShortcuts");
    x(this, "tiptapExtensions");
  }
  static key() {
    throw new Error("You must implement the key method in your extension");
  }
  addProsemirrorPlugin(n) {
    this.plugins.push(n);
  }
  get priority() {
  }
}
function T(e) {
  const t = Object.create(Dn.prototype);
  return t.key = e.key, t.inputRules = e.inputRules, t.keyboardShortcuts = e.keyboardShortcuts, t.plugins = e.plugins ?? [], t.tiptapExtensions = e.tiptapExtensions, t;
}
const je = Symbol.for("blocknote.shikiParser"), ue = Symbol.for(
  "blocknote.shikiHighlighterPromise"
);
function _n(e) {
  const t = globalThis;
  let n, o, r = !1;
  return Vt({
    parser: (a) => {
      if (!e.createHighlighter)
        return process.env.NODE_ENV === "development" && !r && (console.log(
          "For syntax highlighting of code blocks, you must provide a `createCodeBlockSpec({ createHighlighter: () => ... })` function"
        ), r = !0), [];
      if (!n)
        return t[ue] = t[ue] || e.createHighlighter(), t[ue].then(
          (c) => {
            n = c;
          }
        );
      const i = dt(e, a.language);
      return !i || i === "text" || i === "none" || i === "plaintext" || i === "txt" ? [] : n.getLoadedLanguages().includes(i) ? (o || (o = t[je] || Wt(n), t[je] = o), o(a)) : n.loadLanguage(i);
    },
    languageExtractor: (a) => a.attrs.language,
    nodeTypes: ["codeBlock"]
  });
}
const Rn = ({ defaultLanguage: e = "text" }) => ({
  type: "codeBlock",
  propSchema: {
    language: {
      default: e
    }
  },
  content: "inline"
}), Vn = M(
  Rn,
  (e) => ({
    meta: {
      code: !0,
      defining: !0,
      isolating: !1
    },
    parse: (t) => {
      var r, s;
      if (t.tagName !== "PRE" || t.childElementCount !== 1 || ((r = t.firstElementChild) == null ? void 0 : r.tagName) !== "CODE")
        return;
      const n = t.firstElementChild;
      return { language: n.getAttribute("data-language") || ((s = n.className.split(" ").find((a) => a.includes("language-"))) == null ? void 0 : s.replace("language-", "")) };
    },
    parseContent: ({ el: t, schema: n }) => {
      const o = ne.fromSchema(n), r = t.firstElementChild;
      return o.parse(r, {
        preserveWhitespace: "full",
        topNode: n.nodes.codeBlock.create()
      }).content;
    },
    render(t, n) {
      const o = document.createDocumentFragment(), r = document.createElement("pre"), s = document.createElement("code");
      r.appendChild(s);
      let a;
      if (e.supportedLanguages) {
        const i = document.createElement("select");
        Object.entries(e.supportedLanguages ?? {}).forEach(
          ([d, { name: u }]) => {
            const p = document.createElement("option");
            p.value = d, p.text = u, i.appendChild(p);
          }
        ), i.value = t.props.language || e.defaultLanguage || "text";
        const c = (d) => {
          const u = d.target.value;
          n.updateBlock(t.id, { props: { language: u } });
        };
        i.addEventListener("change", c), a = () => i.removeEventListener("change", c);
        const l = document.createElement("div");
        l.contentEditable = "false", l.appendChild(i), o.appendChild(l);
      }
      return o.appendChild(r), {
        dom: o,
        contentDOM: s,
        destroy: () => {
          a == null || a();
        }
      };
    },
    toExternalHTML(t) {
      const n = document.createElement("pre"), o = document.createElement("code");
      return o.className = `language-${t.props.language}`, o.dataset.language = t.props.language, n.appendChild(o), {
        dom: n,
        contentDOM: o
      };
    }
  }),
  (e) => [
    T({
      key: "code-block-highlighter",
      plugins: [_n(e)]
    }),
    T({
      key: "code-block-keyboard-shortcuts",
      keyboardShortcuts: {
        Delete: ({ editor: t }) => t.transact((n) => {
          const { block: o } = t.getTextCursorPosition();
          if (o.type !== "codeBlock")
            return !1;
          const { $from: r } = n.selection;
          return r.parent.textContent ? !1 : (t.removeBlocks([o]), !0);
        }),
        Tab: ({ editor: t }) => e.indentLineWithTab === !1 ? !1 : t.transact((n) => {
          const { block: o } = t.getTextCursorPosition();
          return o.type === "codeBlock" ? (n.insertText("  "), !0) : !1;
        }),
        Enter: ({ editor: t }) => t.transact((n) => {
          const { block: o, nextBlock: r } = t.getTextCursorPosition();
          if (o.type !== "codeBlock")
            return !1;
          const { $from: s } = n.selection, a = s.parentOffset === s.parent.nodeSize - 2, i = s.parent.textContent.endsWith(`

`);
          if (a && i) {
            if (n.delete(s.pos - 2, s.pos), r)
              return t.setTextCursorPosition(r, "start"), !0;
            const [c] = t.insertBlocks(
              [{ type: "paragraph" }],
              o,
              "after"
            );
            return t.setTextCursorPosition(c, "start"), !0;
          }
          return n.insertText(`
`), !0;
        }),
        "Shift-Enter": ({ editor: t }) => t.transact(() => {
          const { block: n } = t.getTextCursorPosition();
          if (n.type !== "codeBlock")
            return !1;
          const [o] = t.insertBlocks(
            // insert a new paragraph
            [{ type: "paragraph" }],
            n,
            "after"
          );
          return t.setTextCursorPosition(o, "start"), !0;
        })
      },
      inputRules: [
        {
          find: /^```(.*?)\s$/,
          replace: ({ match: t }) => {
            const n = t[1].trim();
            return {
              type: "codeBlock",
              props: {
                language: {
                  language: dt(e, n) ?? n
                }.language
              },
              content: []
            };
          }
        }
      ]
    })
  ]
);
function dt(e, t) {
  var n;
  return (n = Object.entries(e.supportedLanguages ?? {}).find(
    ([o, { aliases: r }]) => (r == null ? void 0 : r.includes(t)) || o === t
  )) == null ? void 0 : n[0];
}
const Wn = () => ({
  type: "divider",
  propSchema: {},
  content: "none"
}), jn = M(
  Wn,
  {
    meta: {
      isolating: !1
    },
    parse(e) {
      if (e.tagName === "HR")
        return {};
    },
    render() {
      return {
        dom: document.createElement("hr")
      };
    }
  },
  [
    T({
      key: "divider-block-shortcuts",
      inputRules: [
        {
          find: new RegExp("^---$"),
          replace() {
            return { type: "divider", props: {}, content: [] };
          }
        }
      ]
    })
  ]
), Fe = (e) => ({ url: e.src || void 0 }), Fn = () => ({
  type: "file",
  propSchema: {
    backgroundColor: C.backgroundColor,
    // File name.
    name: {
      default: ""
    },
    // File url.
    url: {
      default: ""
    },
    // File caption.
    caption: {
      default: ""
    }
  },
  content: "none"
}), $n = () => (e) => {
  if (e.tagName === "EMBED") {
    if (e.closest("figure"))
      return;
    const { backgroundColor: t } = B(e);
    return {
      ...Fe(e),
      backgroundColor: t
    };
  }
  if (e.tagName === "FIGURE") {
    const t = ae(e, "embed");
    if (!t)
      return;
    const { targetElement: n, caption: o } = t, { backgroundColor: r } = B(e);
    return {
      ...Fe(n),
      backgroundColor: r,
      caption: o
    };
  }
}, Un = M(Fn, {
  meta: {
    fileBlockAccept: ["*/*"]
  },
  parse: $n(),
  render(e, t) {
    return Me(e, t);
  },
  toExternalHTML(e) {
    if (!e.props.url) {
      const n = document.createElement("p");
      return n.textContent = "Add file", {
        dom: n
      };
    }
    const t = document.createElement("a");
    return t.href = e.props.url, t.textContent = e.props.name || e.props.url, e.props.caption ? ie(t, e.props.caption) : {
      dom: t
    };
  }
}), zn = {
  set: (e, t) => window.localStorage.setItem(
    `toggle-${e.id}`,
    t ? "true" : "false"
  ),
  get: (e) => window.localStorage.getItem(`toggle-${e.id}`) === "true"
}, pt = (e, t, n, o = zn) => {
  if ("isToggleable" in e.props && !e.props.isToggleable)
    return {
      dom: n
    };
  const r = document.createElement("div"), s = document.createElement("div");
  s.className = "bn-toggle-wrapper";
  const a = document.createElement("button");
  a.className = "bn-toggle-button", a.type = "button", a.innerHTML = // https://fonts.google.com/icons?selected=Material+Symbols+Rounded:chevron_right:FILL@0;wght@700;GRAD@0;opsz@24&icon.query=chevron&icon.style=Rounded&icon.size=24&icon.color=%23e8eaed
  '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="CURRENTCOLOR"><path d="M320-200v-560l440 280-440 280Z"/></svg>';
  const i = (h) => h.preventDefault();
  a.addEventListener("mousedown", i);
  const c = () => {
    var h;
    s.getAttribute("data-show-children") === "true" ? (s.setAttribute("data-show-children", "false"), o.set(t.getBlock(e), !1), r.contains(l) && r.removeChild(l)) : (s.setAttribute("data-show-children", "true"), o.set(t.getBlock(e), !0), ((h = t.getBlock(e)) == null ? void 0 : h.children.length) === 0 && !r.contains(l) && r.appendChild(l));
  };
  a.addEventListener("click", c), s.appendChild(a), s.appendChild(n);
  const l = document.createElement("button");
  l.className = "bn-toggle-add-block-button", l.type = "button", l.textContent = t.dictionary.toggle_blocks.add_block_button;
  const d = (h) => h.preventDefault();
  l.addEventListener(
    "mousedown",
    d
  );
  const u = () => {
    t.transact(() => {
      const h = t.updateBlock(e, {
        // Single empty block with default type.
        children: [{}]
      });
      t.setTextCursorPosition(h.children[0].id, "end"), t.focus();
    });
  };
  l.addEventListener("click", u), r.appendChild(s);
  let p = e.children.length;
  const f = t.onChange(() => {
    var k;
    const h = ((k = t.getBlock(e)) == null ? void 0 : k.children.length) ?? 0;
    h > p ? (s.getAttribute("data-show-children") === "false" && (s.setAttribute("data-show-children", "true"), o.set(t.getBlock(e), !0)), r.contains(l) && r.removeChild(l)) : h === 0 && h < p && (s.getAttribute("data-show-children") === "true" && (s.setAttribute("data-show-children", "false"), o.set(t.getBlock(e), !1)), r.contains(l) && r.removeChild(l)), p = h;
  });
  return o.get(e) ? (s.setAttribute("data-show-children", "true"), e.children.length === 0 && r.appendChild(l)) : s.setAttribute("data-show-children", "false"), {
    dom: r,
    // Prevents re-renders when the toggle button is clicked.
    ignoreMutation: (h) => h instanceof MutationRecord && // We want to prevent re-renders when the view changes, so we ignore
    // all mutations where the `data-show-children` attribute is changed
    // or the "add block" button is added/removed.
    (h.type === "attributes" && h.target === s && h.attributeName === "data-show-children" || h.type === "childList" && (h.addedNodes[0] === l || h.removedNodes[0] === l)),
    destroy: () => {
      a.removeEventListener("mousedown", i), a.removeEventListener("click", c), l.removeEventListener(
        "mousedown",
        d
      ), l.removeEventListener(
        "click",
        u
      ), f == null || f();
    }
  };
}, ft = [1, 2, 3, 4, 5, 6], qn = ({
  defaultLevel: e = 1,
  levels: t = ft,
  allowToggleHeadings: n = !0
} = {}) => ({
  type: "heading",
  propSchema: {
    ...C,
    level: { default: e, values: t },
    ...n ? { isToggleable: { default: !1, optional: !0 } } : {}
  },
  content: "inline"
}), Gn = M(
  qn,
  ({ allowToggleHeadings: e = !0 } = {}) => ({
    meta: {
      isolating: !1
    },
    parse(t) {
      let n;
      switch (t.tagName) {
        case "H1":
          n = 1;
          break;
        case "H2":
          n = 2;
          break;
        case "H3":
          n = 3;
          break;
        case "H4":
          n = 4;
          break;
        case "H5":
          n = 5;
          break;
        case "H6":
          n = 6;
          break;
        default:
          return;
      }
      return {
        ...B(t),
        level: n
      };
    },
    render(t, n) {
      const o = document.createElement(`h${t.props.level}`);
      return e ? { ...pt(t, n, o), contentDOM: o } : {
        dom: o,
        contentDOM: o
      };
    },
    toExternalHTML(t) {
      const n = document.createElement(`h${t.props.level}`);
      return O(t.props, n), {
        dom: n,
        contentDOM: n
      };
    }
  }),
  ({ levels: e = ft } = {}) => [
    T({
      key: "heading-shortcuts",
      keyboardShortcuts: Object.fromEntries(
        e.map((t) => [
          `Mod-Alt-${t}`,
          ({ editor: n }) => {
            const o = n.getTextCursorPosition();
            return n.schema.blockSchema[o.block.type].content !== "inline" ? !1 : (n.updateBlock(o.block, {
              type: "heading",
              props: {
                level: t
              }
            }), !0);
          }
        ]) ?? []
      ),
      inputRules: e.map((t) => ({
        find: new RegExp(`^(#{${t}})\\s$`),
        replace({ match: n }) {
          return {
            type: "heading",
            props: {
              level: n[1].length
            }
          };
        }
      }))
    })
  ]
), ht = (e, t, n, o, r) => {
  const { dom: s, destroy: a } = Me(
    e,
    t,
    n,
    r
  ), i = s;
  i.style.position = "relative", e.props.url && e.props.showPreview && (e.props.previewWidth ? i.style.width = `${e.props.previewWidth}px` : i.style.width = "fit-content");
  const c = document.createElement("div");
  c.className = "bn-resize-handle", c.style.left = "4px";
  const l = document.createElement("div");
  l.className = "bn-resize-handle", l.style.right = "4px";
  const d = document.createElement("div");
  d.style.position = "absolute", d.style.height = "100%", d.style.width = "100%";
  let u, p = e.props.previewWidth;
  const f = (g) => {
    var $, U;
    if (!u) {
      !t.isEditable && o.contains(c) && o.contains(l) && (o.removeChild(c), o.removeChild(l));
      return;
    }
    let v;
    const S = "touches" in g ? g.touches[0].clientX : g.clientX;
    e.props.textAlignment === "center" ? u.handleUsed === "left" ? v = u.initialWidth + (u.initialClientX - S) * 2 : v = u.initialWidth + (S - u.initialClientX) * 2 : u.handleUsed === "left" ? v = u.initialWidth + u.initialClientX - S : v = u.initialWidth + S - u.initialClientX, p = Math.min(
      Math.max(v, 64),
      ((U = ($ = t.domElement) == null ? void 0 : $.firstElementChild) == null ? void 0 : U.clientWidth) || Number.MAX_VALUE
    ), i.style.width = `${p}px`;
  }, h = (g) => {
    (!g.target || !i.contains(g.target) || !t.isEditable) && o.contains(c) && o.contains(l) && (o.removeChild(c), o.removeChild(l)), u && (u = void 0, i.contains(d) && i.removeChild(d), t.updateBlock(e, {
      props: {
        previewWidth: p
      }
    }));
  }, k = () => {
    t.isEditable && (o.appendChild(c), o.appendChild(l));
  }, m = (g) => {
    g.relatedTarget === c || g.relatedTarget === l || u || t.isEditable && o.contains(c) && o.contains(l) && (o.removeChild(c), o.removeChild(l));
  }, b = (g) => {
    g.preventDefault(), i.contains(d) || i.appendChild(d);
    const v = "touches" in g ? g.touches[0].clientX : g.clientX;
    u = {
      handleUsed: "left",
      initialWidth: i.clientWidth,
      initialClientX: v
    };
  }, y = (g) => {
    g.preventDefault(), i.contains(d) || i.appendChild(d);
    const v = "touches" in g ? g.touches[0].clientX : g.clientX;
    u = {
      handleUsed: "right",
      initialWidth: i.clientWidth,
      initialClientX: v
    };
  };
  return window.addEventListener("mousemove", f), window.addEventListener("touchmove", f), window.addEventListener("mouseup", h), window.addEventListener("touchend", h), i.addEventListener("mouseenter", k), i.addEventListener("mouseleave", m), c.addEventListener(
    "mousedown",
    b
  ), c.addEventListener(
    "touchstart",
    b
  ), l.addEventListener(
    "mousedown",
    y
  ), l.addEventListener(
    "touchstart",
    y
  ), {
    dom: i,
    destroy: () => {
      a == null || a(), window.removeEventListener("mousemove", f), window.removeEventListener("touchmove", f), window.removeEventListener("mouseup", h), window.removeEventListener("touchend", h), i.removeEventListener("mouseenter", k), i.removeEventListener("mouseleave", m), c.removeEventListener(
        "mousedown",
        b
      ), c.removeEventListener(
        "touchstart",
        b
      ), l.removeEventListener(
        "mousedown",
        y
      ), l.removeEventListener(
        "touchstart",
        y
      );
    }
  };
}, $e = (e) => {
  const t = e.src || void 0, n = e.width || void 0, o = e.alt || void 0;
  return { url: t, previewWidth: n, name: o };
}, Zn = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M5 11.1005L7 9.1005L12.5 14.6005L16 11.1005L19 14.1005V5H5V11.1005ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10Z"></path></svg>', Xn = (e = {}) => ({
  type: "image",
  propSchema: {
    textAlignment: C.textAlignment,
    backgroundColor: C.backgroundColor,
    // File name.
    name: {
      default: ""
    },
    // File url.
    url: {
      default: ""
    },
    // File caption.
    caption: {
      default: ""
    },
    showPreview: {
      default: !0
    },
    // File preview width in px.
    previewWidth: {
      default: void 0,
      type: "number"
    }
  },
  content: "none"
}), Jn = (e = {}) => (t) => {
  if (t.tagName === "IMG") {
    if (t.closest("figure"))
      return;
    const { backgroundColor: n } = B(t);
    return {
      ...$e(t),
      backgroundColor: n
    };
  }
  if (t.tagName === "FIGURE") {
    const n = ae(t, "img");
    if (!n)
      return;
    const { targetElement: o, caption: r } = n, { backgroundColor: s } = B(t);
    return {
      ...$e(o),
      backgroundColor: s,
      caption: r
    };
  }
}, Kn = (e = {}) => (t, n) => {
  const o = document.createElement("div");
  o.innerHTML = e.icon ?? Zn;
  const r = document.createElement("div");
  r.className = "bn-visual-media-wrapper";
  const s = document.createElement("img");
  return s.className = "bn-visual-media", n.resolveFileUrl ? n.resolveFileUrl(t.props.url).then((a) => {
    s.src = a;
  }) : s.src = t.props.url, s.alt = t.props.name || t.props.caption || "BlockNote image", s.contentEditable = "false", s.draggable = !1, r.appendChild(s), ht(
    t,
    n,
    { dom: r },
    r,
    o.firstElementChild
  );
}, Qn = (e = {}) => (t, n) => {
  if (!t.props.url) {
    const r = document.createElement("p");
    return r.textContent = "Add image", {
      dom: r
    };
  }
  let o;
  return t.props.showPreview ? (o = document.createElement("img"), o.src = t.props.url, o.alt = t.props.name || t.props.caption || "BlockNote image", t.props.previewWidth && (o.width = t.props.previewWidth)) : (o = document.createElement("a"), o.href = t.props.url, o.textContent = t.props.name || t.props.url), t.props.caption ? t.props.showPreview ? Te(o, t.props.caption) : ie(o, t.props.caption) : {
    dom: o
  };
}, Yn = M(
  Xn,
  (e) => ({
    meta: {
      fileBlockAccept: ["image/*"]
    },
    parse: Jn(e),
    render: Kn(e),
    toExternalHTML: Qn(e),
    runsBefore: ["file"]
  })
), xr = (e, t, n) => ({
  state: o,
  dispatch: r
}) => r ? mt(o.tr, e, t, n) : !0, mt = (e, t, n, o) => {
  const r = H(e.doc, t), s = D(r);
  if (!s.isBlockContainer)
    return !1;
  const a = j(e), i = [
    {
      type: s.bnBlock.node.type,
      // always keep blockcontainer type
      attrs: o ? { ...s.bnBlock.node.attrs, id: void 0 } : {}
    },
    {
      type: n ? s.blockContent.node.type : a.nodes.paragraph,
      attrs: o ? { ...s.blockContent.node.attrs } : {}
    }
  ];
  return e.split(t, 2, i), !0;
}, ce = (e, t) => {
  const { blockInfo: n, selectionEmpty: o } = e.transact((a) => ({
    blockInfo: Ut(a),
    selectionEmpty: a.selection.anchor === a.selection.head
  }));
  if (!n.isBlockContainer)
    return !1;
  const { bnBlock: r, blockContent: s } = n;
  return s.node.type.name !== t || !o ? !1 : s.node.childCount === 0 ? (e.transact((a) => {
    Be(a, r.beforePos, {
      type: "paragraph",
      props: {}
    });
  }), !0) : s.node.childCount > 0 ? e.transact((a) => (a.deleteSelection(), mt(a, a.selection.from, !0))) : !1;
};
function Le(e, t, n) {
  var u, p, f;
  const o = ne.fromSchema(t), r = e, s = document.createElement("div");
  s.setAttribute("data-node-type", "blockGroup");
  for (const h of Array.from(r.childNodes))
    s.appendChild(h.cloneNode(!0));
  let a = o.parse(s, {
    topNode: t.nodes.blockGroup.create()
  });
  ((p = (u = a.firstChild) == null ? void 0 : u.firstChild) == null ? void 0 : p.type.name) === "checkListItem" && (a = a.copy(
    a.content.cut(
      a.firstChild.firstChild.nodeSize + 2
    )
  ));
  const i = (f = a.firstChild) == null ? void 0 : f.firstChild;
  if (!(i != null && i.isTextblock))
    return W.from(a);
  const c = t.nodes[n].create(
    {},
    i.content
  ), l = a.content.cut(
    // +2 for the `blockGroup` node's start and end markers
    i.nodeSize + 2
  );
  if (l.size > 0) {
    const h = a.copy(l);
    return c.content.addToEnd(h);
  }
  return c.content;
}
const eo = () => ({
  type: "bulletListItem",
  propSchema: {
    ...C
  },
  content: "inline"
}), to = M(
  eo,
  {
    meta: {
      isolating: !1
    },
    parse(e) {
      var n;
      if (e.tagName !== "LI")
        return;
      const t = e.parentElement;
      if (t !== null && (t.tagName === "UL" || t.tagName === "DIV" && ((n = t.parentElement) == null ? void 0 : n.tagName) === "UL"))
        return B(e);
    },
    // As `li` elements can contain multiple paragraphs, we need to merge their contents
    // into a single one so that ProseMirror can parse everything correctly.
    parseContent: ({ el: e, schema: t }) => Le(e, t, "bulletListItem"),
    render() {
      const e = document.createElement("p");
      return {
        dom: e,
        contentDOM: e
      };
    },
    toExternalHTML(e) {
      const t = document.createElement("li"), n = document.createElement("p");
      return O(e.props, t), t.appendChild(n), {
        dom: t,
        contentDOM: n
      };
    }
  },
  [
    T({
      key: "bullet-list-item-shortcuts",
      keyboardShortcuts: {
        Enter: ({ editor: e }) => ce(e, "bulletListItem"),
        "Mod-Shift-8": ({ editor: e }) => {
          const t = e.getTextCursorPosition();
          return e.schema.blockSchema[t.block.type].content !== "inline" ? !1 : (e.updateBlock(t.block, {
            type: "bulletListItem",
            props: {}
          }), !0);
        }
      },
      inputRules: [
        {
          find: new RegExp("^[-+*]\\s$"),
          replace({ editor: e }) {
            if (Qe(
              e.prosemirrorState
            ).blockNoteType !== "heading")
              return {
                type: "bulletListItem",
                props: {}
              };
          }
        }
      ]
    })
  ]
), no = () => ({
  type: "checkListItem",
  propSchema: {
    ...C,
    checked: { default: !1, type: "boolean" }
  },
  content: "inline"
}), oo = M(
  no,
  {
    meta: {
      isolating: !1
    },
    parse(e) {
      var n;
      if (e.tagName === "input")
        return e.closest("[data-content-type]") || e.closest("li") ? void 0 : e.type === "checkbox" ? { checked: e.checked } : void 0;
      if (e.tagName !== "LI")
        return;
      const t = e.parentElement;
      if (t !== null && (t.tagName === "UL" || t.tagName === "DIV" && ((n = t.parentElement) == null ? void 0 : n.tagName) === "UL")) {
        const o = e.querySelector("input[type=checkbox]") || null;
        return o === null ? void 0 : { ...B(e), checked: o.checked };
      }
    },
    // As `li` elements can contain multiple paragraphs, we need to merge their contents
    // into a single one so that ProseMirror can parse everything correctly.
    parseContent: ({ el: e, schema: t }) => Le(e, t, "checkListItem"),
    render(e, t) {
      const n = document.createDocumentFragment(), o = document.createElement("input");
      o.type = "checkbox", o.checked = e.props.checked, e.props.checked && o.setAttribute("checked", ""), o.addEventListener("change", () => {
        t.updateBlock(e, { props: { checked: !e.props.checked } });
      });
      const r = document.createElement("p");
      return n.appendChild(o), n.appendChild(r), {
        dom: n,
        contentDOM: r
      };
    },
    toExternalHTML(e) {
      const t = document.createElement("li"), n = document.createElement("input");
      n.type = "checkbox", n.checked = e.props.checked, e.props.checked && n.setAttribute("checked", "");
      const o = document.createElement("p");
      return O(e.props, t), t.appendChild(n), t.appendChild(o), {
        dom: t,
        contentDOM: o
      };
    },
    runsBefore: ["bulletListItem"]
  },
  [
    T({
      key: "check-list-item-shortcuts",
      keyboardShortcuts: {
        Enter: ({ editor: e }) => ce(e, "checkListItem"),
        "Mod-Shift-9": ({ editor: e }) => {
          const t = e.getTextCursorPosition();
          return e.schema.blockSchema[t.block.type].content !== "inline" ? !1 : (e.updateBlock(t.block, {
            type: "checkListItem",
            props: {}
          }), !0);
        }
      },
      inputRules: [
        {
          find: new RegExp("\\[\\s*\\]\\s$"),
          replace() {
            return {
              type: "checkListItem",
              props: {
                checked: !1
              },
              content: []
            };
          }
        },
        {
          find: new RegExp("\\[[Xx]\\]\\s$"),
          replace() {
            return {
              type: "checkListItem",
              props: {
                checked: !0
              }
            };
          }
        }
      ]
    })
  ]
);
function gt(e, t, n, o) {
  let r = e.firstChild.attrs.start || 1, s = !0;
  const a = !!e.firstChild.attrs.start, i = D({
    posBeforeNode: t,
    node: e
  });
  if (!i.isBlockContainer)
    throw new Error("impossible");
  const c = n.doc.resolve(i.bnBlock.beforePos).nodeBefore, l = c ? o.get(c) : void 0;
  return l !== void 0 ? (r = l + 1, s = !1) : c && D({
    posBeforeNode: i.bnBlock.beforePos - c.nodeSize,
    node: c
  }).blockNoteType === "numberedListItem" && (r = gt(
    c,
    i.bnBlock.beforePos - c.nodeSize,
    n,
    o
  ).index + 1, s = !1), o.set(e, r), { index: r, isFirst: s, hasStart: a };
}
function Ue(e, t) {
  const n = /* @__PURE__ */ new Map(), o = t.decorations.map(
    e.mapping,
    e.doc
  ), r = [];
  e.doc.nodesBetween(0, e.doc.nodeSize - 2, (a, i) => {
    if (a.type.name === "blockContainer" && a.firstChild.type.name === "numberedListItem") {
      const { index: c, isFirst: l, hasStart: d } = gt(
        a,
        i,
        e,
        n
      );
      if (o.find(
        i,
        i + a.nodeSize,
        (p) => p.index === c && p.isFirst === l && p.hasStart === d
      ).length === 0) {
        const p = e.doc.nodeAt(i + 1);
        r.push(
          // move in by 1 to account for the block container
          Ft.node(i + 1, i + 1 + p.nodeSize, {
            "data-index": c.toString()
          })
        );
      }
    }
  });
  const s = r.flatMap(
    (a) => o.find(a.from, a.to)
  );
  return {
    decorations: o.remove(s).add(e.doc, r)
  };
}
const ro = () => new Xe({
  key: new Je("numbered-list-indexing-decorations"),
  state: {
    init(e, t) {
      return Ue(t.tr, {
        decorations: Pe.empty
      });
    },
    apply(e, t) {
      return !e.docChanged && !e.selectionSet && t.decorations ? t : Ue(e, t);
    }
  },
  props: {
    decorations(e) {
      var t;
      return ((t = this.getState(e)) == null ? void 0 : t.decorations) ?? Pe.empty;
    }
  }
}), so = () => ({
  type: "numberedListItem",
  propSchema: {
    ...C,
    start: { default: void 0, type: "number" }
  },
  content: "inline"
}), ao = M(
  so,
  {
    meta: {
      isolating: !1
    },
    parse(e) {
      var n;
      if (e.tagName !== "LI")
        return;
      const t = e.parentElement;
      if (t !== null && (t.tagName === "OL" || t.tagName === "DIV" && ((n = t.parentElement) == null ? void 0 : n.tagName) === "OL")) {
        const o = parseInt(t.getAttribute("start") || "1"), r = B(e);
        return e.previousElementSibling || o === 1 ? r : {
          ...r,
          start: o
        };
      }
    },
    // As `li` elements can contain multiple paragraphs, we need to merge their contents
    // into a single one so that ProseMirror can parse everything correctly.
    parseContent: ({ el: e, schema: t }) => Le(e, t, "numberedListItem"),
    render() {
      const e = document.createElement("p");
      return {
        dom: e,
        contentDOM: e
      };
    },
    toExternalHTML(e) {
      const t = document.createElement("li"), n = document.createElement("p");
      return O(e.props, t), t.appendChild(n), {
        dom: t,
        contentDOM: n
      };
    }
  },
  [
    T({
      key: "numbered-list-item-shortcuts",
      inputRules: [
        {
          find: new RegExp("^(\\d+)\\.\\s$"),
          replace({ match: e, editor: t }) {
            if (Qe(
              t.prosemirrorState
            ).blockNoteType === "heading")
              return;
            const o = parseInt(e[1]);
            return {
              type: "numberedListItem",
              props: {
                start: o !== 1 ? o : void 0
              }
            };
          }
        }
      ],
      keyboardShortcuts: {
        Enter: ({ editor: e }) => ce(e, "numberedListItem"),
        "Mod-Shift-7": ({ editor: e }) => {
          const t = e.getTextCursorPosition();
          return e.schema.blockSchema[t.block.type].content !== "inline" ? !1 : (e.updateBlock(t.block, {
            type: "numberedListItem",
            props: {}
          }), !0);
        }
      },
      plugins: [ro()]
    })
  ]
), io = () => ({
  type: "toggleListItem",
  propSchema: {
    ...C
  },
  content: "inline"
}), co = M(
  io,
  {
    meta: {
      isolating: !1
    },
    render(e, t) {
      const n = document.createElement("p");
      return { ...pt(
        e,
        t,
        n
      ), contentDOM: n };
    },
    toExternalHTML(e) {
      const t = document.createElement("li"), n = document.createElement("p");
      return O(e.props, t), t.appendChild(n), {
        dom: t,
        contentDOM: n
      };
    }
  },
  [
    T({
      key: "toggle-list-item-shortcuts",
      keyboardShortcuts: {
        Enter: ({ editor: e }) => ce(e, "toggleListItem"),
        "Mod-Shift-6": ({ editor: e }) => {
          const t = e.getTextCursorPosition();
          return e.schema.blockSchema[t.block.type].content !== "inline" ? !1 : (e.updateBlock(t.block, {
            type: "toggleListItem",
            props: {}
          }), !0);
        }
      }
    })
  ]
), lo = () => ({
  type: "pageBreak",
  propSchema: {},
  content: "none"
}), uo = M(
  lo,
  {
    parse(e) {
      if (e.tagName === "DIV" && e.hasAttribute("data-page-break"))
        return {};
    },
    render() {
      const e = document.createElement("div");
      return e.setAttribute("data-page-break", ""), {
        dom: e
      };
    },
    toExternalHTML() {
      const e = document.createElement("div");
      return e.setAttribute("data-page-break", ""), {
        dom: e
      };
    }
  }
), Sr = (e) => e.extend({
  blockSpecs: {
    pageBreak: uo()
  }
}), po = () => ({
  type: "paragraph",
  propSchema: C,
  content: "inline"
}), fo = M(
  po,
  {
    meta: {
      isolating: !1
    },
    parse: (e) => {
      var t;
      if (e.tagName === "P" && (t = e.textContent) != null && t.trim())
        return B(e);
    },
    render: () => {
      const e = document.createElement("p");
      return {
        dom: e,
        contentDOM: e
      };
    },
    toExternalHTML: (e) => {
      const t = document.createElement("p");
      return O(e.props, t), {
        dom: t,
        contentDOM: t
      };
    },
    runsBefore: ["default"]
  },
  [
    T({
      key: "paragraph-shortcuts",
      keyboardShortcuts: {
        "Mod-Alt-0": ({ editor: e }) => {
          const t = e.getTextCursorPosition();
          return e.schema.blockSchema[t.block.type].content !== "inline" ? !1 : (e.updateBlock(t.block, {
            type: "paragraph",
            props: {}
          }), !0);
        }
      }
    })
  ]
), ho = () => ({
  type: "quote",
  propSchema: {
    backgroundColor: C.backgroundColor,
    textColor: C.textColor
  },
  content: "inline"
}), mo = M(
  ho,
  {
    meta: {
      isolating: !1
    },
    parse(e) {
      if (e.tagName === "BLOCKQUOTE") {
        const { backgroundColor: t, textColor: n } = B(e);
        return { backgroundColor: t, textColor: n };
      }
    },
    render() {
      const e = document.createElement("blockquote");
      return {
        dom: e,
        contentDOM: e
      };
    },
    toExternalHTML(e) {
      const t = document.createElement("blockquote");
      return O(e.props, t), {
        dom: t,
        contentDOM: t
      };
    }
  },
  [
    T({
      key: "quote-block-shortcuts",
      keyboardShortcuts: {
        "Mod-Alt-q": ({ editor: e }) => {
          const t = e.getTextCursorPosition();
          return e.schema.blockSchema[t.block.type].content !== "inline" ? !1 : (e.updateBlock(t.block, {
            type: "quote",
            props: {}
          }), !0);
        }
      },
      inputRules: [
        {
          find: new RegExp("^>\\s$"),
          replace() {
            return {
              type: "quote",
              props: {}
            };
          }
        }
      ]
    })
  ]
), go = 35, bt = 120, Br = 31, bo = Ze.create({
  name: "BlockNoteTableExtension",
  addProseMirrorPlugins: () => [
    xt({
      cellMinWidth: go,
      defaultCellMinWidth: bt,
      // We set this to null as we implement our own node view in the table
      // block content. This node view is the same as what's used by default,
      // but is wrapped in a `blockContent` HTML element.
      View: null
    }),
    St()
  ],
  addKeyboardShortcuts() {
    return {
      // Makes enter create a new line within the cell.
      Enter: () => this.editor.state.selection.empty && this.editor.state.selection.$head.parent.type.name === "tableParagraph" ? (this.editor.commands.insertContent({ type: "hardBreak" }), !0) : !1,
      // Ensures that backspace won't delete the table if the text cursor is at
      // the start of a cell and the selection is empty.
      Backspace: () => {
        const e = this.editor.state.selection, t = e.empty, n = e.$head.parentOffset === 0, o = e.$head.node().type.name === "tableParagraph";
        return t && n && o;
      },
      // Enables navigating cells using the tab key.
      Tab: () => this.editor.commands.command(
        ({ state: e, dispatch: t, view: n }) => Ne(1)(e, t, n)
      ),
      "Shift-Tab": () => this.editor.commands.command(
        ({ state: e, dispatch: t, view: n }) => Ne(-1)(e, t, n)
      )
    };
  },
  extendNodeSchema(e) {
    const t = {
      name: e.name,
      options: e.options,
      storage: e.storage
    };
    return {
      tableRole: Dt(
        _t(e, "tableRole", t)
      )
    };
  }
}), ko = {
  textColor: C.textColor
}, Co = V.create({
  name: "tableHeader",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  /**
   * We allow table headers and cells to have multiple tableContent nodes because
   * when merging cells, prosemirror-tables will concat the contents of the cells naively.
   * This would cause that content to overflow into other cells when prosemirror tries to enforce the cell structure.
   *
   * So, we manually fix this up when reading back in the `nodeToBlock` and only ever place a single tableContent back into the cell.
   */
  content: "tableContent+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (e) => {
          const t = e.getAttribute("colwidth");
          return t ? t.split(",").map((o) => parseInt(o, 10)) : null;
        }
      }
    };
  },
  tableRole: "header_cell",
  isolating: !0,
  parseHTML() {
    return [
      {
        tag: "th",
        // As `th` elements can contain multiple paragraphs, we need to merge their contents
        // into a single one so that ProseMirror can parse everything correctly.
        getContent: (e, t) => kt(e, t)
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "th",
      be(this.options.HTMLAttributes, e),
      0
    ];
  }
}), yo = V.create({
  name: "tableCell",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "tableContent+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (e) => {
          const t = e.getAttribute("colwidth");
          return t ? t.split(",").map((o) => parseInt(o, 10)) : null;
        }
      }
    };
  },
  tableRole: "cell",
  isolating: !0,
  parseHTML() {
    return [
      {
        tag: "td",
        // As `td` elements can contain multiple paragraphs, we need to merge their contents
        // into a single one so that ProseMirror can parse everything correctly.
        getContent: (e, t) => kt(e, t)
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "td",
      be(this.options.HTMLAttributes, e),
      0
    ];
  }
}), wo = V.create({
  name: "table",
  content: "tableRow+",
  group: "blockContent",
  tableRole: "table",
  marks: "deletion insertion modification",
  isolating: !0,
  parseHTML() {
    return [
      {
        tag: "table"
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    var r, s, a;
    const n = nn(
      this.name,
      "table",
      {
        ...((r = this.options.domAttributes) == null ? void 0 : r.blockContent) || {},
        ...t
      },
      ((s = this.options.domAttributes) == null ? void 0 : s.inlineContent) || {}
    ), o = document.createElement("colgroup");
    for (const i of e.children[0].children)
      if (i.attrs.colwidth)
        for (const l of i.attrs.colwidth) {
          const d = document.createElement("col");
          l && (d.style = `width: ${l}px`), o.appendChild(d);
        }
      else
        o.appendChild(document.createElement("col"));
    return (a = n.dom.firstChild) == null || a.appendChild(o), n;
  },
  // This node view is needed for the `columnResizing` plugin. By default, the
  // plugin adds its own node view, which overrides how the node is rendered vs
  // `renderHTML`. This means that the wrapping `blockContent` HTML element is
  // no longer rendered. The `columnResizing` plugin uses the `TableView` as its
  // default node view. `BlockNoteTableView` extends it by wrapping it in a
  // `blockContent` element, so the DOM structure is consistent with other block
  // types.
  addNodeView() {
    return ({ node: e, HTMLAttributes: t }) => {
      var o;
      class n extends Bt {
        constructor(s, a, i) {
          super(s, a), this.node = s, this.cellMinWidth = a, this.blockContentHTMLAttributes = i;
          const c = document.createElement("div");
          c.className = Z(
            "bn-block-content",
            i.class
          ), c.setAttribute("data-content-type", "table");
          for (const [p, f] of Object.entries(
            i
          ))
            p !== "class" && c.setAttribute(p, f);
          const l = this.dom, d = document.createElement("div");
          d.className = "tableWrapper-inner", d.appendChild(l.firstChild), l.appendChild(d), c.appendChild(l);
          const u = document.createElement("div");
          u.className = "table-widgets-container", u.style.position = "relative", l.appendChild(u), this.dom = c;
        }
        ignoreMutation(s) {
          return !s.target.closest(".tableWrapper-inner") || super.ignoreMutation(s);
        }
      }
      return new n(e, bt, {
        ...((o = this.options.domAttributes) == null ? void 0 : o.blockContent) || {},
        ...t
      });
    };
  }
}), vo = V.create({
  name: "tableParagraph",
  group: "tableContent",
  content: "inline*",
  parseHTML() {
    return [
      {
        tag: "p",
        getAttrs: (e) => {
          if (typeof e == "string" || !e.textContent || !e.closest("[data-content-type]"))
            return !1;
          const t = e.parentElement;
          return t === null ? !1 : t.tagName === "TD" || t.tagName === "TH" ? {} : !1;
        },
        node: "tableParagraph"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["p", e, 0];
  }
}), Eo = V.create({
  name: "tableRow",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "(tableCell | tableHeader)+",
  tableRole: "row",
  marks: "deletion insertion modification",
  parseHTML() {
    return [{ tag: "tr" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "tr",
      be(this.options.HTMLAttributes, e),
      0
    ];
  }
});
function kt(e, t) {
  const o = ne.fromSchema(t).parse(e, {
    topNode: t.nodes.blockGroup.create()
  }), r = [];
  return o.content.descendants((s) => {
    if (s.isInline)
      return r.push(s), !1;
  }), W.fromArray(r);
}
const xo = () => an(
  { node: wo, type: "table", content: "table" },
  ko,
  [
    T({
      key: "table-extensions",
      tiptapExtensions: [
        bo,
        vo,
        Co,
        yo,
        Eo
      ]
    }),
    // Extension for keyboard shortcut which deletes the table if it's empty
    // and all cells are selected. Uses a separate extension as it needs
    // priority over keyboard handlers in the `TableExtension`'s
    // `tableEditing` plugin.
    T({
      key: "table-keyboard-delete",
      keyboardShortcuts: {
        Backspace: ({ editor: e }) => {
          if (!(e.prosemirrorState.selection instanceof Ge))
            return !1;
          const t = e.getTextCursorPosition().block, n = t.content;
          let o = 0;
          for (const s of n.rows)
            for (const a of s.cells) {
              if ("type" in a && a.content.length > 0 || !("type" in a) && a.length > 0)
                return !1;
              o++;
            }
          let r = 0;
          return e.prosemirrorState.selection.forEachCell(() => {
            r++;
          }), r < o ? !1 : (e.transact(() => {
            (e.getPrevBlock(t) || e.getNextBlock(t)) && e.setTextCursorPosition(t), e.removeBlocks([t]);
          }), !0);
        }
      }
    })
  ]
), ze = (e) => {
  const t = e.src || void 0, n = e.width || void 0;
  return { url: t, previewWidth: n };
}, So = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM8 5V19H16V5H8ZM4 5V7H6V5H4ZM18 5V7H20V5H18ZM4 9V11H6V9H4ZM18 9V11H20V9H18ZM4 13V15H6V13H4ZM18 13V15H20V13H18ZM4 17V19H6V17H4ZM18 17V19H20V17H18Z"></path></svg>', Bo = (e) => ({
  type: "video",
  propSchema: {
    textAlignment: C.textAlignment,
    backgroundColor: C.backgroundColor,
    name: { default: "" },
    url: { default: "" },
    caption: { default: "" },
    showPreview: { default: !0 },
    previewWidth: { default: void 0, type: "number" }
  },
  content: "none"
}), Mo = (e) => (t) => {
  if (t.tagName === "VIDEO") {
    if (t.closest("figure"))
      return;
    const { backgroundColor: n } = B(t);
    return {
      ...ze(t),
      backgroundColor: n
    };
  }
  if (t.tagName === "FIGURE") {
    const n = ae(t, "video");
    if (!n)
      return;
    const { targetElement: o, caption: r } = n, { backgroundColor: s } = B(t);
    return {
      ...ze(o),
      backgroundColor: s,
      caption: r
    };
  }
}, To = M(
  Bo,
  (e) => ({
    meta: {
      fileBlockAccept: ["video/*"]
    },
    parse: Mo(),
    render(t, n) {
      const o = document.createElement("div");
      o.innerHTML = e.icon ?? So;
      const r = document.createElement("div");
      r.className = "bn-visual-media-wrapper";
      const s = document.createElement("video");
      return s.className = "bn-visual-media", n.resolveFileUrl ? n.resolveFileUrl(t.props.url).then((a) => {
        s.src = a;
      }) : s.src = t.props.url, s.controls = !0, s.contentEditable = "false", s.draggable = !1, s.width = t.props.previewWidth, r.appendChild(s), ht(
        t,
        n,
        { dom: r },
        r,
        o.firstElementChild
      );
    },
    toExternalHTML(t) {
      if (!t.props.url) {
        const o = document.createElement("p");
        return o.textContent = "Add video", {
          dom: o
        };
      }
      let n;
      return t.props.showPreview ? (n = document.createElement("video"), n.src = t.props.url, t.props.previewWidth && (n.width = t.props.previewWidth)) : (n = document.createElement("a"), n.href = t.props.url, n.textContent = t.props.name || t.props.url), t.props.caption ? t.props.showPreview ? Te(n, t.props.caption) : ie(n, t.props.caption) : {
        dom: n
      };
    },
    runsBefore: ["file"]
  })
), Mr = async (e) => {
  const t = new FormData();
  return t.append("file", e), (await (await fetch("https://tmpfiles.org/api/v1/upload", {
    method: "POST",
    body: t
  })).json()).data.url.replace(
    "tmpfiles.org/",
    "tmpfiles.org/dl/"
  );
};
function E(e, t, n) {
  if (!(t in e.schema.blockSpecs))
    return !1;
  if (!n)
    return !0;
  for (const [o, r] of Object.entries(n)) {
    if (!(o in e.schema.blockSpecs[t].config.propSchema))
      return !1;
    if (typeof r == "string") {
      if (e.schema.blockSpecs[t].config.propSchema[o].default !== void 0 && typeof e.schema.blockSpecs[t].config.propSchema[o].default !== r || e.schema.blockSpecs[t].config.propSchema[o].type !== void 0 && e.schema.blockSpecs[t].config.propSchema[o].type !== r)
        return !1;
    } else {
      if (e.schema.blockSpecs[t].config.propSchema[o].default !== r.default || e.schema.blockSpecs[t].config.propSchema[o].default === void 0 && r.default === void 0 && e.schema.blockSpecs[t].config.propSchema[o].type !== r.type || typeof e.schema.blockSpecs[t].config.propSchema[o].values != typeof r.values)
        return !1;
      if (typeof e.schema.blockSpecs[t].config.propSchema[o].values == "object" && typeof r.values == "object") {
        for (const s of r.values)
          if (!e.schema.blockSpecs[t].config.propSchema[o].values.includes(s))
            return !1;
      }
    }
  }
  return !0;
}
function Tr(e, t, n, o) {
  return E(t, n, o) && e.type === n;
}
function Lr(e) {
  return e instanceof Ge;
}
function Lo(e) {
  let t = e.getTextCursorPosition().block, n = e.schema.blockSchema[t.type].content;
  for (; n === "none"; ) {
    if (t = e.getTextCursorPosition().nextBlock, t === void 0)
      return;
    n = e.schema.blockSchema[t.type].content, e.setTextCursorPosition(t, "end");
  }
}
function w(e, t) {
  const n = e.getTextCursorPosition().block;
  if (n.content === void 0)
    throw new Error("Slash Menu open in a block that doesn't contain content.");
  let o;
  return Array.isArray(n.content) && (n.content.length === 1 && I(n.content[0]) && n.content[0].type === "text" && n.content[0].text === "/" || n.content.length === 0) ? (o = e.updateBlock(n, t), e.setTextCursorPosition(o)) : (o = e.insertBlocks([t], n, "after")[0], e.setTextCursorPosition(e.getTextCursorPosition().nextBlock)), Lo(e), o;
}
function Ar(e) {
  const t = [];
  return E(e, "heading", { level: "number" }) && t.push(
    {
      onItemClick: () => {
        w(e, {
          type: "heading",
          props: { level: 1 }
        });
      },
      badge: L("Mod-Alt-1"),
      key: "heading",
      ...e.dictionary.slash_menu.heading
    },
    {
      onItemClick: () => {
        w(e, {
          type: "heading",
          props: { level: 2 }
        });
      },
      badge: L("Mod-Alt-2"),
      key: "heading_2",
      ...e.dictionary.slash_menu.heading_2
    },
    {
      onItemClick: () => {
        w(e, {
          type: "heading",
          props: { level: 3 }
        });
      },
      badge: L("Mod-Alt-3"),
      key: "heading_3",
      ...e.dictionary.slash_menu.heading_3
    }
  ), E(e, "quote") && t.push({
    onItemClick: () => {
      w(e, {
        type: "quote"
      });
    },
    key: "quote",
    ...e.dictionary.slash_menu.quote
  }), E(e, "toggleListItem") && t.push({
    onItemClick: () => {
      w(e, {
        type: "toggleListItem"
      });
    },
    badge: L("Mod-Shift-6"),
    key: "toggle_list",
    ...e.dictionary.slash_menu.toggle_list
  }), E(e, "numberedListItem") && t.push({
    onItemClick: () => {
      w(e, {
        type: "numberedListItem"
      });
    },
    badge: L("Mod-Shift-7"),
    key: "numbered_list",
    ...e.dictionary.slash_menu.numbered_list
  }), E(e, "bulletListItem") && t.push({
    onItemClick: () => {
      w(e, {
        type: "bulletListItem"
      });
    },
    badge: L("Mod-Shift-8"),
    key: "bullet_list",
    ...e.dictionary.slash_menu.bullet_list
  }), E(e, "checkListItem") && t.push({
    onItemClick: () => {
      w(e, {
        type: "checkListItem"
      });
    },
    badge: L("Mod-Shift-9"),
    key: "check_list",
    ...e.dictionary.slash_menu.check_list
  }), E(e, "paragraph") && t.push({
    onItemClick: () => {
      w(e, {
        type: "paragraph"
      });
    },
    badge: L("Mod-Alt-0"),
    key: "paragraph",
    ...e.dictionary.slash_menu.paragraph
  }), E(e, "codeBlock") && t.push({
    onItemClick: () => {
      w(e, {
        type: "codeBlock"
      });
    },
    badge: L("Mod-Alt-c"),
    key: "code_block",
    ...e.dictionary.slash_menu.code_block
  }), E(e, "divider") && t.push({
    onItemClick: () => {
      w(e, { type: "divider" });
    },
    key: "divider",
    ...e.dictionary.slash_menu.divider
  }), E(e, "table") && t.push({
    onItemClick: () => {
      w(e, {
        type: "table",
        content: {
          type: "tableContent",
          rows: [
            {
              cells: ["", "", ""]
            },
            {
              cells: ["", "", ""]
            }
          ]
        }
      });
    },
    badge: void 0,
    key: "table",
    ...e.dictionary.slash_menu.table
  }), E(e, "image", { url: "string" }) && t.push({
    onItemClick: () => {
      const n = w(e, {
        type: "image"
      });
      e.transact(
        (o) => o.setMeta(e.filePanel.plugins[0], {
          block: n
        })
      );
    },
    key: "image",
    ...e.dictionary.slash_menu.image
  }), E(e, "video", { url: "string" }) && t.push({
    onItemClick: () => {
      const n = w(e, {
        type: "video"
      });
      e.transact(
        (o) => o.setMeta(e.filePanel.plugins[0], {
          block: n
        })
      );
    },
    key: "video",
    ...e.dictionary.slash_menu.video
  }), E(e, "audio", { url: "string" }) && t.push({
    onItemClick: () => {
      const n = w(e, {
        type: "audio"
      });
      e.transact(
        (o) => o.setMeta(e.filePanel.plugins[0], {
          block: n
        })
      );
    },
    key: "audio",
    ...e.dictionary.slash_menu.audio
  }), E(e, "file", { url: "string" }) && t.push({
    onItemClick: () => {
      const n = w(e, {
        type: "file"
      });
      e.transact(
        (o) => o.setMeta(e.filePanel.plugins[0], {
          block: n
        })
      );
    },
    key: "file",
    ...e.dictionary.slash_menu.file
  }), E(e, "heading", {
    level: "number",
    isToggleable: "boolean"
  }) && t.push(
    {
      onItemClick: () => {
        w(e, {
          type: "heading",
          props: { level: 1, isToggleable: !0 }
        });
      },
      key: "toggle_heading",
      ...e.dictionary.slash_menu.toggle_heading
    },
    {
      onItemClick: () => {
        w(e, {
          type: "heading",
          props: { level: 2, isToggleable: !0 }
        });
      },
      key: "toggle_heading_2",
      ...e.dictionary.slash_menu.toggle_heading_2
    },
    {
      onItemClick: () => {
        w(e, {
          type: "heading",
          props: { level: 3, isToggleable: !0 }
        });
      },
      key: "toggle_heading_3",
      ...e.dictionary.slash_menu.toggle_heading_3
    }
  ), E(e, "heading", { level: "number" }) && (e.schema.blockSchema.heading.propSchema.level.values || []).filter((n) => n > 3).forEach((n) => {
    t.push({
      onItemClick: () => {
        w(e, {
          type: "heading",
          props: { level: n }
        });
      },
      key: `heading_${n}`,
      ...e.dictionary.slash_menu[`heading_${n}`]
    });
  }), t.push({
    onItemClick: () => {
      e.openSuggestionMenu(":", {
        deleteTriggerCharacter: !0,
        ignoreQueryLength: !0
      });
    },
    key: "emoji",
    ...e.dictionary.slash_menu.emoji
  }), t;
}
function Nr(e, t) {
  return e.filter(
    ({ title: n, aliases: o }) => n.toLowerCase().includes(t.toLowerCase()) || o && o.filter(
      (r) => r.toLowerCase().includes(t.toLowerCase())
    ).length !== 0
  );
}
function Ao(e) {
  return "pageBreak" in e.schema.blockSchema;
}
function Ir(e) {
  const t = [];
  return Ao(e) && t.push({
    ...e.dictionary.slash_menu.page_break,
    onItemClick: () => {
      w(e, {
        type: "pageBreak"
      });
    },
    key: "page_break"
  }), t;
}
const No = {
  audio: On(),
  bulletListItem: to(),
  checkListItem: oo(),
  codeBlock: Vn(),
  divider: jn(),
  file: Un(),
  heading: Gn(),
  image: Yn(),
  numberedListItem: ao(),
  paragraph: fo(),
  quote: mo(),
  table: xo(),
  toggleListItem: co(),
  video: To()
}, Io = at(
  {
    type: "textColor",
    propSchema: "string"
  },
  {
    render: () => {
      const e = document.createElement("span");
      return {
        dom: e,
        contentDOM: e
      };
    },
    toExternalHTML: (e) => {
      const t = document.createElement("span");
      return e !== C.textColor.default && (t.style.color = e in A ? A[e].text : e), {
        dom: t,
        contentDOM: t
      };
    },
    parse: (e) => {
      if (e.tagName === "SPAN" && e.style.color)
        return e.style.color;
    }
  }
), Po = at(
  {
    type: "backgroundColor",
    propSchema: "string"
  },
  {
    render: () => {
      const e = document.createElement("span");
      return {
        dom: e,
        contentDOM: e
      };
    },
    toExternalHTML: (e) => {
      const t = document.createElement("span");
      return e !== C.backgroundColor.default && (t.style.backgroundColor = e in A ? A[e].background : e), {
        dom: t,
        contentDOM: t
      };
    },
    parse: (e) => {
      if (e.tagName === "SPAN" && e.style.backgroundColor)
        return e.style.backgroundColor;
    }
  }
), Ct = {
  bold: z(Mt, "boolean"),
  italic: z(Lt, "boolean"),
  underline: z(Nt, "boolean"),
  strike: z(At, "boolean"),
  code: z(Tt, "boolean"),
  textColor: Io,
  backgroundColor: Po
}, Pr = st(Ct), yt = {
  text: { config: "text", implementation: {} },
  link: { config: "link", implementation: {} }
}, Or = ot(
  yt
);
class wt extends Cn {
  static create(t) {
    return new wt({
      blockSpecs: (t == null ? void 0 : t.blockSpecs) ?? No,
      inlineContentSpecs: (t == null ? void 0 : t.inlineContentSpecs) ?? yt,
      styleSpecs: (t == null ? void 0 : t.styleSpecs) ?? Ct
    });
  }
}
export {
  He as $,
  oo as A,
  so as B,
  ao as C,
  io as D,
  Br as E,
  Ln as F,
  co as G,
  lo as H,
  uo as I,
  Sr as J,
  po as K,
  fo as L,
  ho as M,
  mo as N,
  ko as O,
  xo as P,
  So as Q,
  Bo as R,
  Mo as S,
  To as T,
  zn as U,
  pt as V,
  Mr as W,
  Ao as X,
  Ir as Y,
  wt as Z,
  nn as _,
  bt as a,
  Be as a$,
  on as a0,
  No as a1,
  Ct as a2,
  Pr as a3,
  yt as a4,
  Or as a5,
  E as a6,
  Tr as a7,
  Lr as a8,
  C as a9,
  Qe as aA,
  xr as aB,
  kr as aC,
  Xt as aD,
  mr as aE,
  pr as aF,
  gr as aG,
  dr as aH,
  it as aI,
  yn as aJ,
  wn as aK,
  br as aL,
  fr as aM,
  hr as aN,
  Z as aO,
  Ye as aP,
  Ko as aQ,
  er as aR,
  Cr as aS,
  ar as aT,
  nr as aU,
  Qt as aV,
  ye as aW,
  D as aX,
  Yo as aY,
  en as aZ,
  or as a_,
  B as aa,
  O as ab,
  wr as ac,
  vr as ad,
  Er as ae,
  Zt as af,
  R as ag,
  cr as ah,
  lr as ai,
  rn as aj,
  ur as ak,
  j as al,
  se as am,
  tr as an,
  K as ao,
  Kt as ap,
  lt as aq,
  J as ar,
  Jt as as,
  H as at,
  Gt as au,
  xe as av,
  Dn as aw,
  Hn as ax,
  $t as ay,
  Ut as az,
  Nn as b,
  Jo as b0,
  xn as b1,
  Ce as b2,
  we as b3,
  ve as b4,
  F as b5,
  Ee as b6,
  T as b7,
  A as b8,
  yr as b9,
  rr as bA,
  te as bB,
  sr as bC,
  pe as bD,
  q as bE,
  Se as bF,
  G as bG,
  fe as bH,
  Qo as bI,
  w as ba,
  Ar as bb,
  Nr as bc,
  cn as bd,
  ln as be,
  un as bf,
  ir as bg,
  M as bh,
  sn as bi,
  he as bj,
  an as bk,
  dn as bl,
  ot as bm,
  Oe as bn,
  et as bo,
  I as bp,
  fn as bq,
  at as br,
  pn as bs,
  Y as bt,
  rt as bu,
  z as bv,
  st as bw,
  Cn as bx,
  tn as by,
  L as bz,
  An as c,
  In as d,
  Pn as e,
  On as f,
  Rn as g,
  Vn as h,
  dt as i,
  Wn as j,
  jn as k,
  Fn as l,
  $n as m,
  Un as n,
  qn as o,
  We as p,
  Gn as q,
  Zn as r,
  Xn as s,
  Jn as t,
  Kn as u,
  Qn as v,
  Yn as w,
  eo as x,
  to as y,
  no as z
};
//# sourceMappingURL=BlockNoteSchema-Dl4x6Xj0.js.map
